webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "9JCF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _ajaxutils = __webpack_require__("q+s0");

var _ajaxutils2 = _interopRequireDefault(_ajaxutils);

var _wsUtils = __webpack_require__("GEX2");

var _wsUtils2 = _interopRequireDefault(_wsUtils);

var _utils = __webpack_require__("mF0L");

var _utils2 = _interopRequireDefault(_utils);

var _shelltool = __webpack_require__("tf+u");

var _shelltool2 = _interopRequireDefault(_shelltool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var public_path = "https://static.h5bqb.top/static/images/";
var file_icon = public_path + "file_icon.svg";
var pic_uploading = public_path + "pic_uploading.png";
var video_bg = public_path + "video_bg.png";
var READ_DWELL_MS = 500;
var READ_VISIBLE_RATIO = 0.6;
var READ_LAYOUT_CHECK_DELAY = 160;
var READ_RECEIPT_QUEUE_STORAGE_PREFIX = "zhini_read_receipt_queue_";

var readReceiptState = {
  initialized: false,
  pageVisible: true,
  pageFocused: true,
  pendingReadMid: "",
  pendingSeenMids: [],
  pendingTimerId: null,
  layoutCheckTimerId: null,
  resizeObserver: null,
  mutationObserver: null,
  seenIncomingMids: {},
  lastReportedReadMid: "",
  queuedReadMid: "",
  isFlushing: false,
  showNewMessageHint: false,
  messageContents: {}
};

window.addEventListener("offline", function (e) {
  var sysMsg = {
    msgtype: "system",
    content: "网络连接已断开，请检查网络！",
    mid: "native_" + new Date().getTime()
  };
  showMoreMessage(sysMsg, true);
});

var getReadableMsgTime = function getReadableMsgTime(msgTime) {
  if (msgTime) {
    msgTime = msgTime.replace(/-/g, "/");
    var msgYear = new Date(msgTime).getFullYear();
    var curYear = new Date().getFullYear();
    if (msgYear < curYear) {
      return msgTime;
    } else {
      return msgTime.slice(5);
    }
  } else {
    return "";
  }
};

var getMessageStatusImg = function getMessageStatusImg(msg, flag) {
  if (!flag || !msg.result) {
    return "";
  }
  return "<span id=\"" + msg.ackid + "_status\" title=\"\u6B63\u5728\u53D1\u9001...\" class=\"message-status message-status--loading\" aria-label=\"\u6B63\u5728\u53D1\u9001\"></span>";
};

var escapeHtmlAttr = function escapeHtmlAttr(value) {
  return String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

var normalizeMessageMid = function normalizeMessageMid(mid) {
  if (mid === undefined || mid === null || mid === "") {
    return "";
  }
  return String(mid);
};

var getReadMessageId = function getReadMessageId(data) {
  return normalizeMessageMid(data && data.mid);
};

var getRawMessageContent = function getRawMessageContent(data) {
  if (!data || data.content === undefined || data.content === null) {
    return "";
  }
  return String(data.content);
};

var getReadStatus = function getReadStatus(data) {
  if (!data || data.read_status === undefined || data.read_status === null || data.read_status === "") {
    return 0;
  }
  var status = Number(data.read_status);
  if (status === 1 || status === 2) {
    return status;
  }
  return 0;
};

var rememberReadMessageContent = function rememberReadMessageContent(mid, content) {
  if (!mid) {
    return;
  }
  readReceiptState.messageContents[mid] = content || "";
};

var getReadMessageContentByMid = function getReadMessageContentByMid(mid) {
  if (!mid || !Object.prototype.hasOwnProperty.call(readReceiptState.messageContents, mid)) {
    return "";
  }
  return readReceiptState.messageContents[mid];
};

var getFileTarget = function getFileTarget(data) {
  var contentHtml = "<img class=\"file-icon\" src=\"" + file_icon + "\" />\n                    <div class=\"file-title single-line\" style={{ width:'165px', whiteSpace:'nowrap'}}>" + _utils2.default.truncateFileName(data.title, 185) + "</div>\n                    <div class=\"file-size\">" + _utils2.default.formatStorageSize(data.size) + "</div>";
  return data.content ? "<a href=\"" + data.content + "\" target=\"_blank\" class=\"inner-card\">" + contentHtml + "</a>" : "<div class=\"inner-card\">" + contentHtml + "</div>";
};

var resolveVideoConfig = function resolveVideoConfig(msg) {
  var result = { height: msg.height, width: msg.width };
  if (result.height > 180) {
    result.width = 180 * result.width / result.height;
    result.height = 180;
  }
  if (result.width > 240) {
    result.height = 240 * result.height / result.width;
    result.width = 240;
  }
  return result;
};

window.showImage = function (event) {
  // 发送 largeImg 消息到父窗口（SDK iframe）
  _shelltool2.default.postMessage({ type: "largeImg", data: { url: event.target.src } });
};

window.showVideo = function (event) {
  event.stopPropagation();
  var targetSrc = event.target.dataset.src;
  if (targetSrc && targetSrc.indexOf('https://cdn.wykefu.com/') == -1) {
    return;
  }

  _shelltool2.default.postMessage({ type: "previewVideo", data: { url: targetSrc } });
};

var createMessageHtml = function createMessageHtml(data, params) {
  params = params || {};
  var rightMsg = params.rightMessage || data.uid == data.from_uid;
  var readMessageId = getReadMessageId(data);
  var readMessageContent = getRawMessageContent(data);
  var readSource = params.readSource || "";
  var readStatus = getReadStatus(data);
  var canReportRead = !rightMsg && readMessageId && (readStatus === 0 || readStatus === 1);
  var statusSending = getMessageStatusImg(data, rightMsg);
  var htmlId = readMessageId ? "mid_" + readMessageId : data.ackid;
  var msgContent = "";

  switch (data.msgtype) {
    case "system":
      {
        if (params.createNode) {
          var messageItem = document.createElement("div");
          messageItem.className = "message-tag";
          messageItem.innerHTML = "<div class=\"content\">" + getReadableMsgTime(data.ctime) + " " + data.content + "</div>";
          return messageItem;
        }
        return "<div class=\"message-tag\">\n                <div class=\"content\">" + getReadableMsgTime(data.ctime) + " " + data.content + "</div>\n              </div>";
      }
    case "emotion":
    case "image":
      {
        msgContent = "<div class=\"message-img\">\n            " + statusSending + "\n            <img id=\"" + htmlId + "_img\" class=\"msg-img link-style\" onclick=\"showImage(event)\" src=\"" + data.content + "\" />\n            </div>";
        break;
      }
    case "file":
      {
        msgContent = "<div class=\"inner-card-outer\" id=\"" + htmlId + "_outer\">\n                " + statusSending + "\n                " + getFileTarget(data) + "\n            </div>";
        break;
      }
    case "video":
      {
        var _resolveVideoConfig = resolveVideoConfig(data),
            height = _resolveVideoConfig.height,
            width = _resolveVideoConfig.width;

        var duration = Math.ceil(data.duration || 0);
        var result = duration % 60;
        msgContent = "<div id=\"" + htmlId + "_video\" class=\"message-video message-img\" onclick=\"showVideo(event)\" data-src=\"" + data.content + "\" style=\"width:" + width + "px; height:" + height + "px; background-image: url(" + data.thumb + "); background-size: cover;\">\n            " + statusSending + "\n            <div class=\"video-play-btn\" id=\"" + htmlId + "_video_btn\" style=\"opacity:" + (data.content ? 1 : 0) + "\" onclick=\"showVideo(event)\" data-src=\"" + data.content + "\"></div>\n            <div class=\"v-duration\" id=\"" + htmlId + "_video_duration\">" + (parseInt(duration / 60) + (result < 10 ? ":0" + result : ":" + result)) + "</div>\n            </div>";
        break;
      }
    case "link":
      {
        msgContent = "<div class=\"inner-card-outer\" id=\"" + htmlId + "_outer\">\n              <a href=" + data.thumb_url + " target=\"_blank\" class=\"inner-card\">\n                <div class=\"content-img\" style=\"background-image: url(" + data.content + ")\"></div>\n                <div class=\"content-title\">" + data.title + "</div>\n                <div class=\"content-des\">" + data.description + "</div>\n                </a>\n            </div>";
        break;
      }
    default:
      {
        var RMsg = _utils2.default.linkifyText(_utils2.default.replaceTag(data.content));
        var LMsg = _utils2.default.linkifyText(data.content.indexOf('<') > -1 && data.content.indexOf('>') > -1 ? _utils2.default.replaceSpecialTag(data.content) : data.content);
        var emotionParsedRContent = qqWechatEmotionParser(RMsg);
        var emotionParsedLContent = qqWechatEmotionParser(LMsg);
        msgContent = "\n        <span class=\"message-text\">\n          " + statusSending + "\n          <pre>" + (rightMsg ? emotionParsedRContent : emotionParsedLContent) + "</pre>\n        </span>\n      ";
        break;
      }
  }
  var fromName = data.from_name || "";
  if (!rightMsg && loginData.kefu_name_from) {
    fromName = loginData.kefu_name_from;
  }
  if (!rightMsg && readMessageId) {
    rememberReadMessageContent(readMessageId, readMessageContent);
  }
  if (params.createNode) {
    var _messageItem = document.createElement("div");
    _messageItem.id = htmlId;
    _messageItem.className = "message-item" + (rightMsg ? " message-right" : " message-incoming");
    if (readMessageId) {
      _messageItem.setAttribute("data-mid", readMessageId);
    }
    if (!rightMsg && readMessageId) {
      _messageItem.setAttribute("data-read-status", String(readStatus));
    }
    if (canReportRead) {
      _messageItem.setAttribute("data-read-target", "1");
      if (readSource) {
        _messageItem.setAttribute("data-read-source", readSource);
      }
    }
    _messageItem.innerHTML = "<div class=\"name\">" + fromName + " " + getReadableMsgTime(data.ctime) + "</div>\n        " + msgContent + "\n        <div class=\"clear-both\"></div>";
    return _messageItem;
  }
  var messageMidAttr = readMessageId ? " data-mid=\"" + escapeHtmlAttr(readMessageId) + "\"" : "";
  var readStatusAttr = !rightMsg && readMessageId ? " data-read-status=\"" + readStatus + "\"" : "";
  var readTargetAttr = canReportRead ? ' data-read-target="1"' : "";
  var readSourceAttr = readTargetAttr && readSource ? " data-read-source=\"" + escapeHtmlAttr(readSource) + "\"" : "";
  return "<div class=\"message-item" + (rightMsg ? " message-right" : " message-incoming") + "\" id=\"" + htmlId + "\"" + messageMidAttr + readStatusAttr + readTargetAttr + readSourceAttr + ">\n        <div class=\"name\">" + fromName + " " + getReadableMsgTime(data.ctime) + "</div>\n        " + msgContent + "\n        <div class=\"clear-both\"></div>\n        </div>";
};

var getMessageListElement = function getMessageListElement() {
  return document.getElementById("msg-wrapper");
};

// 记录 HTTP 已确认的 mid，过滤同一消息的 WebSocket 回推。
var MESSAGE_MID_CACHE_TTL = 10 * 60 * 1000;
var MESSAGE_MID_CACHE_PRUNE_INTERVAL = 60 * 1000;
var messageMidCache = (0, _create2.default)(null);
var nextMessageMidCachePruneAt = 0;

var getMessageElementByMid = function getMessageElementByMid(mid) {
  var messageMid = normalizeMessageMid(mid);
  return messageMid ? document.getElementById("mid_" + messageMid) : null;
};

var pruneMessageMidCache = function pruneMessageMidCache(now) {
  (0, _keys2.default)(messageMidCache).forEach(function (key) {
    if (now - messageMidCache[key] > MESSAGE_MID_CACHE_TTL) {
      delete messageMidCache[key];
    }
  });
  nextMessageMidCachePruneAt = now + MESSAGE_MID_CACHE_PRUNE_INTERVAL;
};

var rememberMessageMid = function rememberMessageMid(mid) {
  var messageMid = normalizeMessageMid(mid);
  if (!messageMid) {
    return;
  }
  var now = new Date().getTime();
  if (now >= nextMessageMidCachePruneAt) {
    pruneMessageMidCache(now);
  }
  messageMidCache[messageMid] = now;
};

var isMessageMidRemembered = function isMessageMidRemembered(mid) {
  var messageMid = normalizeMessageMid(mid);
  if (!messageMid) {
    return false;
  }
  var rememberedAt = messageMidCache[messageMid];
  if (rememberedAt === undefined) {
    return false;
  }
  if (new Date().getTime() - rememberedAt > MESSAGE_MID_CACHE_TTL) {
    delete messageMidCache[messageMid];
    return false;
  }
  return true;
};

var filterDuplicateMessages = function filterDuplicateMessages(messages, checkExistingDom) {
  var seenMids = (0, _create2.default)(null);
  return (messages || []).filter(function (item) {
    var messageMid = getReadMessageId(item);
    // 没有 mid 的消息不参与去重，保持正常展示。
    if (!messageMid) {
      return true;
    }
    if (Object.prototype.hasOwnProperty.call(seenMids, messageMid)) {
      return false;
    }
    seenMids[messageMid] = true;
    return !checkExistingDom || !getMessageElementByMid(messageMid);
  });
};

var getLatestClientId = function getLatestClientId() {
  var channelId = urlParams.channel_id || localStorage.getItem("zhini_channel_id") || "";
  return window._ZHINI_INIT_CLIENT_ID || localStorage.getItem("zhini_init_client_id_" + channelId) || localStorage.getItem("zhini_client_id_" + channelId) || "";
};

var getInitUserStorageKey = function getInitUserStorageKey(channelId, field) {
  return "zhini_init_user_" + field + "_" + channelId;
};

var isValidAvatarUrl = function isValidAvatarUrl(value) {
  if (typeof value !== "string") {
    return false;
  }
  var url = value.trim();
  if (!/^https?:\/\//i.test(url)) {
    return false;
  }
  try {
    var parsedUrl = new URL(url);
    var pathname = parsedUrl.pathname || "";
    return (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(pathname)
    );
  } catch (err) {}
  return false;
};

var getStoredInitUserValue = function getStoredInitUserValue(channelId, field) {
  if (!channelId) {
    return "";
  }
  try {
    return localStorage.getItem(getInitUserStorageKey(channelId, field)) || "";
  } catch (err) {}
  return "";
};

var getLatestInitUserInfo = function getLatestInitUserInfo() {
  var channelId = urlParams.channel_id || localStorage.getItem("zhini_channel_id") || "";
  var avatar = window._ZHINI_INIT_USER_AVATAR || getStoredInitUserValue(channelId, "avatar");
  return {
    name: window._ZHINI_INIT_USER_NAME || getStoredInitUserValue(channelId, "name"),
    avatar: isValidAvatarUrl(avatar) ? avatar : ""
  };
};

var applyInitUserParams = function applyInitUserParams(params) {
  var initUserInfo = getLatestInitUserInfo();
  delete params.name;
  delete params.nickname;
  delete params.avatar;
  if (initUserInfo.name) {
    params.name = initUserInfo.name;
  }
  if (initUserInfo.avatar) {
    params.avatar = initUserInfo.avatar;
  }
};

var buildNewloginRequestData = function buildNewloginRequestData() {
  var requestData = {};
  var appendIfPresent = function appendIfPresent(key) {
    var value = urlParams[key];
    if (value !== undefined && value !== null && value !== "") {
      requestData[key] = value;
    }
  };
  ["channel_id", "client_id", "name", "avatar", "domain"].forEach(appendIfPresent);
  requestData.location = urlParams.location || "";
  requestData.adddomain = true;
  return requestData;
};

var getReadReceiptStorageKey = function getReadReceiptStorageKey() {
  var channelId = urlParams.channel_id || localStorage.getItem("zhini_channel_id") || "";
  return READ_RECEIPT_QUEUE_STORAGE_PREFIX + channelId + "_" + getLatestClientId();
};

var getReadReceiptUrl = function getReadReceiptUrl() {
  return "/wykf/api/v1/enterprise/message/read";
};

var isChatPanelOpen = function isChatPanelOpen() {
  return _shelltool2.default.getifameState() === 1;
};

var updateReadReceiptWindowState = function updateReadReceiptWindowState() {
  readReceiptState.pageVisible = document.visibilityState !== "hidden" && !document.hidden;
  readReceiptState.pageFocused = readReceiptState.pageVisible;
};

var clearPendingReadTimer = function clearPendingReadTimer() {
  if (readReceiptState.pendingTimerId) {
    clearTimeout(readReceiptState.pendingTimerId);
  }
  readReceiptState.pendingTimerId = null;
  readReceiptState.pendingReadMid = "";
  readReceiptState.pendingSeenMids = [];
};

var getReadReceiptMessageNodes = function getReadReceiptMessageNodes() {
  var list = getMessageListElement();
  if (!list) {
    return [];
  }
  return Array.prototype.slice.call(list.querySelectorAll('[data-read-target="1"][data-mid]'));
};

var getVisibleIncomingMids = function getVisibleIncomingMids() {
  var list = getMessageListElement();
  if (!list) {
    return [];
  }
  var listRect = list.getBoundingClientRect();
  return getReadReceiptMessageNodes().filter(function (item) {
    var rect = item.getBoundingClientRect();
    var visibleTop = Math.max(rect.top, listRect.top);
    var visibleBottom = Math.min(rect.bottom, listRect.bottom);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var readableHeight = Math.min(rect.height, listRect.height);
    var visibleRatio = readableHeight > 0 ? visibleHeight / readableHeight : 0;
    return visibleRatio >= READ_VISIBLE_RATIO;
  }).map(function (item) {
    return item.getAttribute("data-mid");
  });
};

var isNearMessageBottom = function isNearMessageBottom() {
  var list = getMessageListElement();
  if (!list) {
    return true;
  }
  return list.scrollHeight - list.scrollTop - list.clientHeight < 48;
};

var areSameMids = function areSameMids(left, right) {
  if (left.length !== right.length) {
    return false;
  }
  return left.every(function (mid, index) {
    return mid === right[index];
  });
};

var getLastMidByDomOrder = function getLastMidByDomOrder(mids) {
  var midMap = {};
  mids.forEach(function (mid) {
    midMap[mid] = true;
  });
  var nodes = getReadReceiptMessageNodes();
  for (var index = nodes.length - 1; index >= 0; index--) {
    var mid = nodes[index].getAttribute("data-mid");
    if (midMap[mid]) {
      return mid;
    }
  }
  return "";
};

var getReadCandidate = function getReadCandidate() {
  var nodes = getReadReceiptMessageNodes();
  var reportedMid = readReceiptState.lastReportedReadMid;
  var hasReportedNode = !!reportedMid && nodes.some(function (node) {
    return node.getAttribute("data-mid") === reportedMid;
  });
  var shouldCheck = !reportedMid || !hasReportedNode;
  var candidate = reportedMid;

  for (var index = 0; index < nodes.length; index++) {
    var mid = nodes[index].getAttribute("data-mid");
    if (!mid) {
      continue;
    }
    if (!shouldCheck) {
      if (mid === reportedMid) {
        shouldCheck = true;
      }
      continue;
    }
    if (mid === candidate) {
      continue;
    }
    if (!readReceiptState.seenIncomingMids[mid]) {
      break;
    }
    candidate = mid;
  }

  return candidate;
};

var canAdvanceReadMid = function canAdvanceReadMid(mid) {
  if (!mid || mid === readReceiptState.lastReportedReadMid) {
    return false;
  }
  if (!readReceiptState.lastReportedReadMid) {
    return true;
  }
  var nodes = getReadReceiptMessageNodes();
  var candidateIndex = -1;
  var reportedIndex = -1;
  for (var index = 0; index < nodes.length; index++) {
    var nodeMid = nodes[index].getAttribute("data-mid");
    if (nodeMid === mid) {
      candidateIndex = index;
    }
    if (nodeMid === readReceiptState.lastReportedReadMid) {
      reportedIndex = index;
    }
  }
  if (candidateIndex !== -1 && reportedIndex !== -1) {
    return candidateIndex > reportedIndex;
  }
  return true;
};

var isReadMidCovered = function isReadMidCovered(candidateMid, targetMid) {
  if (!candidateMid || !targetMid) {
    return false;
  }
  if (candidateMid === targetMid) {
    return true;
  }
  var nodes = getReadReceiptMessageNodes();
  var candidateIndex = -1;
  var targetIndex = -1;
  for (var index = 0; index < nodes.length; index++) {
    var nodeMid = nodes[index].getAttribute("data-mid");
    if (nodeMid === candidateMid) {
      candidateIndex = index;
    }
    if (nodeMid === targetMid) {
      targetIndex = index;
    }
  }
  return candidateIndex !== -1 && targetIndex !== -1 && candidateIndex >= targetIndex;
};

var isReportableReadMid = function isReportableReadMid(mid) {
  if (!mid) {
    return false;
  }
  var nodes = getReadReceiptMessageNodes();
  for (var index = 0; index < nodes.length; index++) {
    if (nodes[index].getAttribute("data-mid") === mid) {
      var readStatus = nodes[index].getAttribute("data-read-status");
      return readStatus === "0" || readStatus === "1";
    }
  }
  return false;
};

var normalizeReadMids = function normalizeReadMids(mids) {
  var source = Array.isArray(mids) ? mids : [mids];
  var midMap = {};
  var result = [];
  source.forEach(function (mid) {
    if (mid && !midMap[mid]) {
      midMap[mid] = true;
      result.push(mid);
    }
  });
  return result;
};

var getReportableReadMidsThrough = function getReportableReadMidsThrough(targetMid) {
  if (!targetMid) {
    return [];
  }
  var nodes = getReadReceiptMessageNodes();
  var reportedMid = readReceiptState.lastReportedReadMid;
  var hasReportedNode = !!reportedMid && nodes.some(function (node) {
    return node.getAttribute("data-mid") === reportedMid;
  });
  var shouldCollect = !reportedMid || !hasReportedNode;
  var mids = [];
  for (var index = 0; index < nodes.length; index++) {
    var mid = nodes[index].getAttribute("data-mid");
    if (!mid) {
      continue;
    }
    if (!shouldCollect) {
      if (mid === reportedMid) {
        shouldCollect = true;
      }
      continue;
    }
    if (readReceiptState.seenIncomingMids[mid] && isReportableReadMid(mid)) {
      mids.push(mid);
    }
    if (mid === targetMid) {
      break;
    }
  }
  return mids;
};

var setNewMessageHintVisible = function setNewMessageHintVisible(visible) {
  readReceiptState.showNewMessageHint = visible;
  var hint = document.getElementById("read-new-message-hint");
  if (hint) {
    hint.style.display = visible ? "block" : "none";
  }
};

var ensureNewMessageHint = function ensureNewMessageHint() {
  var hint = document.getElementById("read-new-message-hint");
  if (hint) {
    return hint;
  }
  var container = document.querySelector(".body-left") || document.querySelector(".chat-body") || document.body;
  if (!container) {
    return null;
  }
  hint = document.createElement("button");
  hint.id = "read-new-message-hint";
  hint.className = "read-new-message-hint";
  hint.type = "button";
  hint.innerText = "有新消息，点击回到底部";
  hint.style.display = "none";
  hint.onclick = function () {
    setNewMessageHintVisible(false);
    _utils2.default.scrollDownEnd(undefined, 0);
    scheduleReadReceiptCheck(350);
  };
  container.appendChild(hint);
  return hint;
};

var queueReadReceipt = function queueReadReceipt(mid) {
  if (!mid) {
    return;
  }
  readReceiptState.queuedReadMid = mid;
  try {
    localStorage.setItem(getReadReceiptStorageKey(), mid);
  } catch (err) {}
};

var clearQueuedReadReceipt = function clearQueuedReadReceipt() {
  readReceiptState.queuedReadMid = "";
  try {
    localStorage.removeItem(getReadReceiptStorageKey());
  } catch (err) {}
};

var hydrateQueuedReadReceipt = function hydrateQueuedReadReceipt() {
  if (readReceiptState.queuedReadMid) {
    return;
  }
  try {
    readReceiptState.queuedReadMid = localStorage.getItem(getReadReceiptStorageKey()) || "";
  } catch (err) {}
};

var resolveLastReadMid = function resolveLastReadMid(payload) {
  if (!payload) {
    return "";
  }
  if (payload.mid) {
    return String(payload.mid);
  }
  if (payload.lastReadMid) {
    return String(payload.lastReadMid);
  }
  if (payload.last_read_mid) {
    return String(payload.last_read_mid);
  }
  if (payload.readMid) {
    return String(payload.readMid);
  }
  if (payload.read_mid) {
    return String(payload.read_mid);
  }
  if (payload.data) {
    return resolveLastReadMid(payload.data);
  }
  return "";
};

var syncSeenIncomingMidsByDomOrder = function syncSeenIncomingMidsByDomOrder() {
  var reportedMid = readReceiptState.lastReportedReadMid;
  if (!reportedMid) {
    return;
  }
  var nodes = getReadReceiptMessageNodes();
  var reportedIndex = -1;
  for (var index = 0; index < nodes.length; index++) {
    if (nodes[index].getAttribute("data-mid") === reportedMid) {
      reportedIndex = index;
      break;
    }
  }
  if (reportedIndex === -1) {
    readReceiptState.seenIncomingMids[reportedMid] = true;
    return;
  }
  for (var _index = 0; _index <= reportedIndex; _index++) {
    var mid = nodes[_index].getAttribute("data-mid");
    if (mid) {
      readReceiptState.seenIncomingMids[mid] = true;
    }
  }
};

var markHistoryReadTargetsSeen = function markHistoryReadTargetsSeen() {
  var list = getMessageListElement();
  if (!list) {
    return;
  }
  Array.prototype.slice.call(list.querySelectorAll('.message-incoming[data-mid]')).forEach(function (node) {
    var mid = node.getAttribute("data-mid");
    var readStatus = node.getAttribute("data-read-status");
    if (mid && readStatus === "2") {
      readReceiptState.seenIncomingMids[mid] = true;
    }
  });
};

var syncLastReportedReadMid = function syncLastReportedReadMid(payload) {
  var lastReadMid = resolveLastReadMid(payload);
  if (!lastReadMid) {
    return false;
  }
  readReceiptState.lastReportedReadMid = lastReadMid;
  readReceiptState.seenIncomingMids[lastReadMid] = true;
  syncSeenIncomingMidsByDomOrder();
  if (readReceiptState.queuedReadMid === lastReadMid || isReadMidCovered(lastReadMid, readReceiptState.queuedReadMid)) {
    clearQueuedReadReceipt();
  }
  return true;
};

var sendReadReceipt = function sendReadReceipt(mids) {
  var readMids = normalizeReadMids(mids);
  if (readMids.length === 0 || readReceiptState.isFlushing || !loginData.token) {
    return;
  }
  var lastMid = getLastMidByDomOrder(readMids) || readMids[readMids.length - 1];
  readReceiptState.isFlushing = true;
  _ajaxutils2.default.httpRequest({
    type: "POST",
    url: getReadReceiptUrl(),
    contentType: "application/json; charset=UTF-8",
    data: {
      mids: readMids,
      read_status: 2,
      token: loginData.token
    },
    success: function success(result) {
      readReceiptState.lastReportedReadMid = resolveLastReadMid(result) || lastMid;
      readMids.forEach(function (mid) {
        readReceiptState.seenIncomingMids[mid] = true;
      });
      readReceiptState.seenIncomingMids[readReceiptState.lastReportedReadMid] = true;
      clearQueuedReadReceipt();
      readReceiptState.isFlushing = false;
    },
    error: function error() {
      if (!window.navigator.onLine) {
        queueReadReceipt(lastMid);
      } else if (readReceiptState.queuedReadMid === lastMid) {
        clearQueuedReadReceipt();
      }
      readReceiptState.isFlushing = false;
    }
  });
};

var attemptFlushQueuedReadReceipt = function attemptFlushQueuedReadReceipt() {
  hydrateQueuedReadReceipt();
  if (!readReceiptState.queuedReadMid || !window.navigator.onLine || readReceiptState.isFlushing) {
    return;
  }
  if (!isReportableReadMid(readReceiptState.queuedReadMid)) {
    clearQueuedReadReceipt();
    return;
  }
  if (readReceiptState.queuedReadMid === readReceiptState.lastReportedReadMid || isReadMidCovered(readReceiptState.lastReportedReadMid, readReceiptState.queuedReadMid)) {
    clearQueuedReadReceipt();
    return;
  }
  var queuedReadMids = getReportableReadMidsThrough(readReceiptState.queuedReadMid);
  sendReadReceipt(queuedReadMids.length ? queuedReadMids : readReceiptState.queuedReadMid);
};

var confirmVisibleReadMids = function confirmVisibleReadMids(mids) {
  readReceiptState.pendingTimerId = null;
  updateReadReceiptWindowState();
  var visibleMidMap = {};
  getVisibleIncomingMids().forEach(function (mid) {
    visibleMidMap[mid] = true;
  });
  var confirmedMids = mids.filter(function (mid) {
    return visibleMidMap[mid];
  });
  if (!isChatPanelOpen() || !readReceiptState.pageVisible || !readReceiptState.pageFocused || confirmedMids.length === 0) {
    return;
  }
  confirmedMids.forEach(function (mid) {
    readReceiptState.seenIncomingMids[mid] = true;
  });
  readReceiptState.pendingReadMid = "";
  readReceiptState.pendingSeenMids = [];
  var readMids = confirmedMids.filter(function (mid) {
    return isReportableReadMid(mid);
  });
  if (readMids.length === 0) {
    return;
  }
  var readCandidate = getLastMidByDomOrder(readMids) || readMids[readMids.length - 1];
  if (!window.navigator.onLine) {
    queueReadReceipt(readCandidate);
    return;
  }
  sendReadReceipt(readMids);
};

var reevaluateReadReceiptCandidate = function reevaluateReadReceiptCandidate() {
  updateReadReceiptWindowState();
  if (!isChatPanelOpen() || !readReceiptState.pageVisible || !readReceiptState.pageFocused) {
    clearPendingReadTimer();
    return;
  }
  var visibleMids = getVisibleIncomingMids();
  var candidate = getReadCandidate();
  if (isReadMidCovered(candidate, readReceiptState.queuedReadMid)) {
    attemptFlushQueuedReadReceipt();
  }
  var pendingMids = visibleMids.filter(function (mid) {
    return !readReceiptState.seenIncomingMids[mid] && isReportableReadMid(mid);
  });
  if (pendingMids.length === 0) {
    clearPendingReadTimer();
    return;
  }
  var pendingReadMid = getLastMidByDomOrder(pendingMids);
  if (readReceiptState.pendingTimerId && readReceiptState.pendingReadMid === pendingReadMid && areSameMids(readReceiptState.pendingSeenMids, pendingMids)) {
    return;
  }
  clearPendingReadTimer();
  readReceiptState.pendingReadMid = pendingReadMid;
  readReceiptState.pendingSeenMids = pendingMids;
  readReceiptState.pendingTimerId = setTimeout(function () {
    confirmVisibleReadMids(pendingMids);
  }, READ_DWELL_MS);
};

var scheduleReadReceiptCheck = function scheduleReadReceiptCheck(delay) {
  setTimeout(reevaluateReadReceiptCandidate, delay || 0);
};

var scheduleReadReceiptLayoutCheck = function scheduleReadReceiptLayoutCheck(delay) {
  if (readReceiptState.layoutCheckTimerId) {
    clearTimeout(readReceiptState.layoutCheckTimerId);
  }
  readReceiptState.layoutCheckTimerId = setTimeout(function () {
    readReceiptState.layoutCheckTimerId = null;
    reevaluateReadReceiptCandidate();
  }, delay || READ_LAYOUT_CHECK_DELAY);
};

var bindReadReceiptMediaLoad = function bindReadReceiptMediaLoad(root) {
  if (!root || !root.querySelectorAll) {
    return;
  }
  Array.prototype.slice.call(root.querySelectorAll("img")).forEach(function (img) {
    if (img.getAttribute("data-read-receipt-load-bound") === "1") {
      return;
    }
    img.setAttribute("data-read-receipt-load-bound", "1");
    img.addEventListener("load", function () {
      scheduleReadReceiptLayoutCheck();
    });
    img.addEventListener("error", function () {
      scheduleReadReceiptLayoutCheck();
    });
    if (img.complete) {
      scheduleReadReceiptLayoutCheck();
    }
  });
};

var observeReadReceiptNodes = function observeReadReceiptNodes(root) {
  if (!root || !root.querySelectorAll || !readReceiptState.resizeObserver) {
    return;
  }
  var nodes = root.matches && root.matches('[data-read-target="1"][data-mid]') ? [root] : Array.prototype.slice.call(root.querySelectorAll('[data-read-target="1"][data-mid]'));
  nodes.forEach(function (node) {
    if (node.getAttribute("data-read-receipt-observed") === "1") {
      return;
    }
    node.setAttribute("data-read-receipt-observed", "1");
    readReceiptState.resizeObserver.observe(node);
  });
};

var initReadReceiptLayoutWatcher = function initReadReceiptLayoutWatcher(list) {
  if (!list) {
    return;
  }
  bindReadReceiptMediaLoad(list);
  if (window.ResizeObserver && !readReceiptState.resizeObserver) {
    readReceiptState.resizeObserver = new ResizeObserver(function () {
      scheduleReadReceiptLayoutCheck();
    });
    observeReadReceiptNodes(list);
  }
  if (window.MutationObserver && !readReceiptState.mutationObserver) {
    readReceiptState.mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes).forEach(function (node) {
          bindReadReceiptMediaLoad(node);
          observeReadReceiptNodes(node);
        });
      });
      scheduleReadReceiptLayoutCheck();
    });
    readReceiptState.mutationObserver.observe(list, {
      childList: true,
      subtree: true
    });
  }
};

var initReadReceiptWatcher = function initReadReceiptWatcher() {
  if (readReceiptState.initialized) {
    return;
  }
  readReceiptState.initialized = true;
  hydrateQueuedReadReceipt();
  ensureNewMessageHint();
  var list = getMessageListElement();
  if (list) {
    initReadReceiptLayoutWatcher(list);
    list.addEventListener("scroll", function () {
      if (isNearMessageBottom()) {
        setNewMessageHintVisible(false);
      }
      reevaluateReadReceiptCandidate();
    });
  }
  window.addEventListener("focus", reevaluateReadReceiptCandidate);
  window.addEventListener("blur", reevaluateReadReceiptCandidate);
  window.addEventListener("online", attemptFlushQueuedReadReceipt);
  window.addEventListener("resize", scheduleReadReceiptLayoutCheck);
  document.addEventListener("visibilitychange", reevaluateReadReceiptCandidate);
  window.handleZhiniPanelOpen = function () {
    setNewMessageHintVisible(false);
    scheduleReadReceiptCheck(350);
  };
  window.handleZhiniPanelClose = function () {
    clearPendingReadTimer();
  };
};

var isRequestMessageListLoading = false;
// 页面级状态不写入浏览器存储，刷新或新开 Tab 时都会重新初始化。
var getPageConnectionState = function getPageConnectionState() {
  if (!window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__) {
    window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__ = {
      wsOpened: false,
      initialMessageListLoaded: false
    };
  }
  return window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__;
};

var requestMessageList = function requestMessageList(history, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!history && isRequestMessageListLoading) {
    return;
  }
  if (!history) {
    isRequestMessageListLoading = true;
  }
  var params = { token: loginData.token };
  var historyElement = void 0;
  if (history) {
    historyElement = document.getElementById("more-history");
    historyElement.children[0].style.display = "none";
    historyElement.children[1].style.display = "block";
    params.forward = 1;
    params.mid = lastMid;
  }
  params.version = "0.1.3";
  var latestClientId = localStorage.getItem('zhini_init_client_id_' + urlParams.channel_id) || localStorage.getItem('zhini_client_id_' + urlParams.channel_id);
  if (latestClientId) {
    params.client_id = latestClientId;
  }
  _ajaxutils2.default.httpRequest({
    url: "/wykf/api/v1/enterprise/webplugin/message",
    data: params,
    success: function success(result) {
      if (!history) {
        isRequestMessageListLoading = false;
      }
      syncLastReportedReadMid(result.data);
      var msg = result.data.msg || [];
      var displayMsg = filterDuplicateMessages(msg, !!history);
      messageLength += msg.length;
      msg.length && (lastMid = msg[0].mid);
      var readSource = history ? "more-history" : "initial-history";
      var resultHtml = displayMsg.map(function (item) {
        return createMessageHtml(item, { readSource: readSource });
      });
      if (history) {
        var node = document.getElementById("msg-wrapper");
        var newNode = document.createElement("div");
        newNode.innerHTML = resultHtml.join("");
        node.insertBefore(newNode, node.childNodes[1]);
        markHistoryReadTargetsSeen();
        // 滚动到指定消息位置
        var msgWrapperRef = document.getElementById("msg-wrapper");
        if (msgWrapperRef && msg.length) {
          var lastMsgInBatch = msg[msg.length - 1];
          if (lastMsgInBatch && normalizeMessageMid(lastMsgInBatch.mid)) {
            var targetElement = getMessageElementByMid(lastMsgInBatch.mid);
            if (targetElement) {
              targetElement.scrollIntoView({
                block: "start"
              });
            }
          }
        }

        if (msg.length < 10) {
          historyElement.innerHTML = '<div class="content">没有更多了！</div>';
          setTimeout(function () {
            historyElement[_utils2.default.IsIE || _utils2.default.IsIE11 ? "removeNode" : "remove"](true);
          }, 3000);
        } else {
          historyElement.children[0].style.display = "block";
          historyElement.children[1].style.display = "none";
        }
        scheduleReadReceiptCheck(350);
      } else {
        document.getElementById("msg-wrapper").innerHTML = (msg.length < 10 ? "" : '<div id="more-history"><div onclick="requestMessageList(1)" class="content">加载更多历史消息</div><div style="display: none;" class="content">加载中...</div></div>') + resultHtml.join("");
        markHistoryReadTargetsSeen();
        _utils2.default.scrollDownEnd();
        setNewMessageHintVisible(false);
        scheduleReadReceiptCheck(350);
        window.requestHis = true;
        cb && cb(1);
        var shouldShowRecoveryMessage = !history && options.showRecoveryMessage === true && getPageConnectionState().initialMessageListLoaded;
        if (!history) {
          getPageConnectionState().initialMessageListLoaded = true;
        }
        if (shouldShowRecoveryMessage) {
          var sysMsg = {
            msgtype: "system",
            content: "连接已恢复！",
            mid: "native_" + new Date().getTime()
          };
          showMoreMessage(sysMsg, true);
        }
      }
    },
    error: function error(_error) {
      if (!history) {
        isRequestMessageListLoading = false;
      }
      if (history) {
        historyElement.children[0].style.display = "block";
        historyElement.children[1].style.display = "none";
      }
      if (_error && (_error.sta === 10003 || _error.errcode === 10003)) {
        startProcess({
          errcode: 10003,
          token: _error.token || loginData.token,
          type: "needMsgList"
        });
      }
    }
  });
};

window.requestMessageList = requestMessageList;

var initEmojiFunction = function initEmojiFunction() {
  document.getElementById("emoji-btn").onclick = function () {
    var emojiDialog = document.getElementById("emoji-dialog");
    if (emojiDialog) {
      emojiDialog.style.display = "block";
    } else {
      emojiDialog = document.createElement("div");
      emojiDialog.id = "emoji-dialog";
      emojiDialog.innerHTML = "<div class=\"qq-emo-c\" style=\"width:" + (_utils2.default.IsPcMode ? "440px" : "95%") + "\">\n                " + window._qqWechatEmotionParser.emotion_map.map(function (item, index) {
        return item.map(function (cItem, cIndex) {
          return "<img class=\"wx-emo-img link-style\" style=\"background-position: " + -28 * cIndex + "px " + -28 * index + "px\"\n                                    src=\"https://wx.qq.com/zh_CN/htmledition/v2/images/spacer.gif\"\n                                    alt=\"" + cItem.cn + "\" />";
        }).join("");
      }).join("") + "\n            </div>";

      emojiDialog.onclick = function (event) {
        if (event.target.className == "qq-emo-c") {
          return;
        }
        var element = document.getElementById("textarea");
        var newValue = event.target.alt;
        emojiDialog.style.display = "none";
        if (!newValue) {
          return;
        }
        var start = element.selectionStart;
        element.value = element.value.slice(0, start) + newValue + element.value.slice(start);
        start += newValue.length;
        element.focus();
        element.setSelectionRange(start, start);
      };
      document.body.appendChild(emojiDialog);
    }
  };
};

var WS_UNAVAILABLE_MESSAGE = "网络异常，请刷新后重新打开客服窗口发送消息";
var wsUnavailableToastTimer = null;

var showWsUnavailableToast = function showWsUnavailableToast() {
  var container = document.querySelector(".body-left") || document.querySelector(".chat-body") || document.body;
  if (!container) {
    return;
  }
  var computedPosition = window.getComputedStyle(container).position;
  if (!computedPosition || computedPosition === "static") {
    container.style.position = "relative";
  }
  var toast = document.getElementById("ws-unavailable-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "ws-unavailable-toast";
    toast.innerHTML = '<span class="ws-unavailable-toast__icon">!</span><span class="ws-unavailable-toast__text"></span>';
    toast.style.cssText = "position:absolute;left:50%;bottom:116px;transform:translateX(-50%);z-index:30;display:flex;align-items:center;gap:8px;max-width:calc(100% - 32px);padding:10px 14px;border-radius:18px;background:rgba(0,0,0,.78);color:#fff;font-size:13px;line-height:18px;box-shadow:0 8px 20px rgba(0,0,0,.2);";
    var icon = toast.querySelector(".ws-unavailable-toast__icon");
    icon.style.cssText = "flex:0 0 18px;width:18px;height:18px;border-radius:50%;background:#ff4d4f;color:#fff;font-weight:700;font-size:13px;line-height:18px;text-align:center;";
    var text = toast.querySelector(".ws-unavailable-toast__text");
    text.style.cssText = "word-break:break-all;";
    container.appendChild(toast);
  }
  toast.querySelector(".ws-unavailable-toast__text").textContent = WS_UNAVAILABLE_MESSAGE;
  toast.style.display = "flex";
  if (wsUnavailableToastTimer) {
    clearTimeout(wsUnavailableToastTimer);
  }
  wsUnavailableToastTimer = setTimeout(function () {
    toast.style.display = "none";
  }, 2500);
};

var markMessageAsFailed = function markMessageAsFailed(nextItem, canRetry) {
  var node = document.getElementById(nextItem.ackid + "_status");
  if (!node) {
    return;
  }
  node.className = "message-status message-status--failed";
  node.removeAttribute("aria-label");
  node.title = canRetry ? "消息发送失败，点击重新发送" : "发送失败";
  node.onclick = null;
  node.style.cursor = canRetry ? "pointer" : "default";
  if (canRetry) {
    node.onclick = function () {
      node.className = "message-status message-status--loading";
      node.setAttribute("aria-label", "正在发送");
      node.title = "发送中...";
      node.style.cursor = "default";
      setTimeout(function () {
        if (typeof nextItem.retryAction === "function") {
          nextItem.retryAction();
          return;
        }
        sendMessage(nextItem, 1);
      }, 1000);
    };
  }
};

var ensureWsAvailable = function ensureWsAvailable(nextItem) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (_wsUtils2.default.isWsAvailable()) {
    return true;
  }
  if (_wsUtils2.default.isCurrentConsultingActive && _wsUtils2.default.isCurrentConsultingActive()) {
    _wsUtils2.default.startProcess("setConsultingActive", { active: true, reason: "ensure_ws_available" });
    return true;
  }
  if (nextItem && options.showMessage && !document.getElementById(nextItem.ackid)) {
    showMoreMessage(nextItem);
  }
  showWsUnavailableToast();
  nextItem && markMessageAsFailed(nextItem, !!options.canRetry);
  return false;
};

var sendMessage = function sendMessage(nextItem, sendCount) {
  if (!ensureWsAvailable(nextItem, { canRetry: true })) {
    return false;
  }
  _wsUtils2.default.startProcess("sendMsgH", {
    message: nextItem,
    sendCount: sendCount,
    cb: function cb(status) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var sendCount = arguments[2];

      if (status < 0) {
        if (sendCount < 4) {
          if (data.errcode === 10003) {
            startProcess({ errcode: data.errcode, token: data.token });
            setTimeout(function () {
              // FIXME 此处等待3秒待处理成实时获取ws_reconnect_suc的状态
              delete nextItem.ctime;
              delete nextItem.result;
              sendMessage(nextItem, sendCount);
            }, 3000);
            return;
          }
          setTimeout(function () {
            delete nextItem.ctime;
            delete nextItem.result;
            sendMessage(nextItem, sendCount);
          }, 1000);
        }
        markMessageAsFailed(nextItem, true);
      } else {
        var messageMid = normalizeMessageMid(data.mid);
        if (messageMid) {
          rememberMessageMid(messageMid);
          var pendingNode = document.getElementById(nextItem.ackid);
          var echoedNode = getMessageElementByMid(messageMid);
          if (pendingNode) {
            // WebSocket 可能先于 HTTP 回调到达，删除它生成的重复节点，保留本地发送节点。
            if (echoedNode && echoedNode !== pendingNode) {
              echoedNode[_utils2.default.IsIE || _utils2.default.IsIE11 ? "removeNode" : "remove"](true);
            }
            pendingNode.id = "mid_" + messageMid;
          }
        }
        if (nextItem.msgtype == "file") {
          delete nextItem.result;
          document.getElementById(nextItem.ackid + "_outer").innerHTML = getFileTarget(nextItem);
        } else {
          document.getElementById(nextItem.ackid + "_status")[_utils2.default.IsIE || _utils2.default.IsIE11 ? "removeNode" : "remove"](true);
          if (urlParams.channel_id == "5ee1ff983dbf994471042f38" && nextItem.msgtype === "text" && data.content && data.content != "") {
            //针对企微线上渠道优先展示后端返回的数据
            var messageNode = getMessageElementByMid(data.mid);
            if (messageNode) {
              var parent = messageNode.childNodes;
              for (var i = 0; i < parent.length; i++) {
                if (parent[i].className === "message-text") {
                  var childs = parent[i].childNodes;
                  for (var j = 0; j < childs.length; j++) {
                    if (childs[j].nodeName == "PRE") {
                      childs[j].innerHTML = _utils2.default.linkifyText(_utils2.default.replaceSpecialTag(data.content));
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
  return true;
};

var showMoreMessage = function showMoreMessage(nextItem, noRight) {
  var date = new Date();
  nextItem.ctime = _utils2.default.formatDate(date);
  nextItem.result = date.getTime();
  if (nextItem.msgtype == 'video' && nextItem.width == 0 && !nextItem.content) {
    nextItem.thumb = video_bg;
  }
  document.getElementById("msg-wrapper").appendChild(createMessageHtml(nextItem, { rightMessage: !noRight, createNode: true }));
  _utils2.default.scrollDownEnd();
};

var resolveFileInput = function resolveFileInput(event, files, nextItem, fileType, base64, showMore) {
  nextItem.retryAction = function () {
    return resolveFileInput(event, files, nextItem, fileType, base64, true);
  };
  if (!ensureWsAvailable(nextItem, { showMessage: true, canRetry: true })) {
    event && event.target && (event.target.value = "");
    return;
  }
  !showMore && !nextItem.thumb && showMoreMessage(nextItem);
  _ajaxutils2.default.changeInputImg(loginData.token, files, base64, nextItem, function (status, data) {
    if (!status && data.cdn_url) {
      nextItem.content = data.cdn_url;
      if (data.thumb) nextItem.thumb = data.thumb;
      if (data.duration) nextItem.duration = data.duration;
      if (data.fsize) nextItem.size = data.fsize;
      if (fileType) {
        nextItem.size = data.fsize;
        nextItem.title = data.filename;
      } else {
        if (data.width && data.height) {
          //获取宽高渲染
          nextItem.height = data.height;
          nextItem.width = data.width;
          if (nextItem.msgtype == 'video') {
            var ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
            if (ele_btn) {
              ele_btn.style.opacity = 1;
            }
          }
        }
        if (nextItem.thumb) {
          if (data.cdn_url) {
            //获取视频内容渲染
            var ele = document.getElementById(nextItem.ackid + "_video");
            ele && ele.setAttribute("data-src", nextItem.content);
            var _ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
            _ele_btn && _ele_btn.setAttribute("data-src", nextItem.content);
          }
          if (data.thumb) {
            //获取封面渲染
            var _ele = document.getElementById(nextItem.ackid + "_video");

            var _resolveVideoConfig2 = resolveVideoConfig(data),
                height = _resolveVideoConfig2.height,
                width = _resolveVideoConfig2.width;

            if (_ele) {
              _ele.style.backgroundImage = "url(\"" + nextItem.thumb + "\")";
              _ele.style.width = width + "px";
              _ele.style.height = height + "px";
            }
          }
          if (data.duration) {
            //获取时长渲染
            var duration = data.duration || 0;
            var result = duration % 60;
            var ele_duration = document.getElementById(nextItem.ackid + "_video_duration");
            if (ele_duration) {
              ele_duration.innerText = parseInt(duration / 60) + (result < 10 ? ":0" + result : ":" + result);
            }
          }
        } else {
          var _ele2 = document.getElementById(nextItem.ackid + "_img");
          _ele2 && _ele2.setAttribute("src", nextItem.content);
        }
      }
      nextItem.retryAction = function () {
        return sendMessage(nextItem, 1);
      };
      sendMessage(nextItem, 1);
    }
    if (status) {
      if (data.errcode === 10003) {
        startProcess({ errcode: data.errcode, token: data.token });
        setTimeout(function () {
          delete nextItem.ctime;
          delete nextItem.result;
          resolveFileInput(event, files, nextItem, fileType, base64, true);
        }, 3000);
        return;
      }
      var content = '';
      if (data.errcode === -1 || data.errcode === 600) {
        content = data.msg;
      } else {
        content = "\u4E0A\u4F20\u5931\u8D25\uFF0C\u8BF7\u5237\u65B0\u91CD\u8BD5 " + (data.errcode ? "\uFF08" + data.errcode + "\uFF09" : '');
      }
      var sysMsg = {
        msgtype: "system",
        content: content,
        mid: "native_" + new Date().getTime()
      };
      showMoreMessage(sysMsg, true);
      markMessageAsFailed(nextItem, true);
      messageLength++;
    }
    event.target.value = "";
  });
};

var resolveVideoBgImage = function resolveVideoBgImage(files, nextItem, videoEvent, videoFile, msgItem) {
  nextItem.retryAction = function () {
    return resolveVideoBgImage(files, nextItem, videoEvent, videoFile, msgItem);
  };
  if (!ensureWsAvailable(nextItem, { showMessage: true, canRetry: true })) {
    videoEvent && videoEvent.target && (videoEvent.target.value = "");
    return;
  }
  _ajaxutils2.default.changeInputImg(loginData.token, files, undefined, msgItem, // 传递 msgItem 以便设置 return_thumb 参数
  function (status, data) {
    if (!status && data.cdn_url) {
      nextItem.thumb = data.cdn_url; //封面图
      data.cdn_url && nextItem.thumb && showMoreMessage(nextItem);
      if (nextItem.msgtype == 'video') {
        var ele_btn = document.getElementById(nextItem.ackid + "_video_btn");
        if (ele_btn) {
          ele_btn.style.opacity = 1;
        }
      }
      resolveFileInput(videoEvent, videoFile, nextItem);
    }
    if (status) {
      if (data.errcode === 10003) {
        // 重新登录
        startProcess({ errcode: data.errcode, token: data.token });
        return;
      }
      //上传失败弹出失败系统提示
      var content = '';
      if (data.errcode === -1 || data.errcode === 600) {
        content = data.msg;
      } else {
        content = "\u4E0A\u4F20\u5931\u8D25\uFF0C\u8BF7\u5237\u65B0\u91CD\u8BD5 " + (data.errcode ? "\uFF08" + data.errcode + "\uFF09" : '');
      }
      var sysMsg = {
        msgtype: "system",
        content: content,
        mid: "native_" + new Date().getTime()
      };
      !document.getElementById(nextItem.ackid) && showMoreMessage(nextItem);
      markMessageAsFailed(nextItem, true);
      showMoreMessage(sysMsg, true);
    }
  });
};

var initActions = function initActions() {
  var markConsultingTabActive = function markConsultingTabActive(reason) {
    _wsUtils2.default.startProcess("setConsultingActive", { active: true, reason: reason });
  };
  var lastBrowserTabActivatedAt = 0;
  // 浏览器 Tab 或独立窗口重新获得焦点时，先恢复当前 Tab 的 WebSocket。
  var activateCurrentBrowserTab = function activateCurrentBrowserTab() {
    if (document.visibilityState !== "visible") {
      return;
    }
    var now = new Date().getTime();
    if (now - lastBrowserTabActivatedAt < 100) {
      return;
    }
    lastBrowserTabActivatedAt = now;
    _wsUtils2.default.startProcess("setConsultingActive", {
      active: true,
      reason: "tab_visible",
      params: { reason: "tab_visible" }
    });
    // 连接已经可用时立即同步；连接恢复中的场景由 WebSocket onopen 负责同步。
    if (isChatPanelOpen() && _wsUtils2.default.isWsAvailable()) {
      requestMessageList(undefined, undefined, { showRecoveryMessage: false });
    }
  };
  window.handleZhiniTabVisible = activateCurrentBrowserTab;
  document.getElementById("send-btn").onclick = function () {
    markConsultingTabActive("send_button");
    sendTextArea();
  };
  var sendTextArea = function sendTextArea() {
    markConsultingTabActive("send_text");
    var element = document.getElementById("textarea");
    var message = element.value.trim();
    if (!message) {
      return;
    }
    var msgVal = _utils2.default.hasSensitiveWords(message);
    if (msgVal) {
      var sysMsg = {
        msgtype: "system",
        content: "发送消息中包含敏感内容，请编辑后重试。",
        mid: "native_" + new Date().getTime()
      };
      showMoreMessage(sysMsg, true);
      return;
    }
    element.value = "";
    var nextItem = {
      content: _utils2.default.replaceTag(message),
      msgtype: "text",
      ackid: "msg_" + messageLength++
    };
    showMoreMessage(nextItem);
    sendMessage(nextItem, 1);
  };
  var removeEventListeners = function removeEventListeners(videoElement) {
    videoElement.removeEventListener('loadedmetadata', undefined);
    videoElement.removeEventListener('seeked', undefined);
  };
  var handleVideoBg = function handleVideoBg(file, event, files) {
    var videoElement = document.getElementById('video-preview');
    var videoDuration = 0,
        videoThumb = '',
        videoWidth = 0,
        videoHeight = 0,
        hasLogged = false,
        isProcessing = false;

    videoElement.src = URL.createObjectURL(file);
    videoElement.autoplay = true;
    videoElement.muted = true;

    videoElement.addEventListener('loadedmetadata', function () {
      if (isProcessing) return; // 如果已经在处理中，则直接返回
      isProcessing = true; // 标记为正在处理

      videoWidth = this.videoWidth;
      videoHeight = this.videoHeight;
      videoDuration = Math.floor(this.duration);

      if (!videoWidth && !videoHeight) {
        resolveFileInput(event, files, {
          msgtype: "file",
          title: file.name,
          size: file.size,
          ackid: "msg_" + messageLength++
        }, true);
        URL.revokeObjectURL(videoElement.src);
        videoElement.src = '';
        removeEventListeners(videoElement);
        return;
      }
      videoElement.currentTime = 0;
      videoElement.play();
    });

    videoElement.addEventListener('seeked', function () {
      if (hasLogged || !videoWidth || !videoHeight) return;
      var canvas = document.createElement('canvas');
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      videoThumb = canvas.toDataURL('image/png'); // base64
      hasLogged = true; // 设置标志变量为 true，表示已经打印过日志
      videoElement.pause();
      var fileObject = _utils2.default.base64ToFile(videoThumb, "video_bg_" + new Date().getTime());
      var nextItem = {
        msgtype: "video",
        content: '',
        thumb: pic_uploading, //视频封面
        width: videoWidth, //视频宽
        height: videoHeight, // 视频高
        duration: videoDuration, // 时长
        size: file.size, // 文件的大小
        ackid: "msg_" + messageLength++
      };
      resolveVideoBgImage([fileObject], nextItem, event, files, nextItem); // 上传视频封面
      URL.revokeObjectURL(videoElement.src);
      removeEventListeners(videoElement); // 移除所有事件监听器
    });

    videoElement.load();
  };
  var resolveSend = function resolveSend(event) {
    var files = event.target.files;
    var file = files[0];

    if (_utils2.default.isImageFile(file.name)) {
      // 图片限制10M - 提前检查
      if (file.size > 10 * 1024 * 1024) {
        var sysMsg = {
          msgtype: "system",
          content: "图片的大小不能超过10M！",
          mid: "native_" + new Date().getTime()
        };
        showMoreMessage(sysMsg, true);
        return;
      }

      resolveFileInput(event, files, {
        content: pic_uploading,
        msgtype: "image",
        ackid: "msg_" + messageLength++
      });
    } else if (_utils2.default.isVideoFile(file.name)) {
      // 处理视频发送
      if (file) {
        if (file.size > 25 * 1024 * 1024) {
          var _sysMsg = {
            msgtype: "system",
            content: "视频的大小不能超过25M！",
            mid: "native_" + new Date().getTime()
          };
          showMoreMessage(_sysMsg, true);
          return;
        }
        if (_utils2.default.isWindowsPC) {
          handleVideoBg(file, event, files);
        } else {
          resolveFileInput(event, files, {
            msgtype: "video",
            content: '',
            thumb: '',
            width: 0,
            height: 0,
            duration: 0,
            size: 0,
            ackid: "msg_" + messageLength++
          });
        }
      }
    } else {
      // 文件限制25M - 提前检查
      if (file.size > 25 * 1024 * 1024) {
        var _sysMsg2 = {
          msgtype: "system",
          content: "文件的大小不能超过25M！",
          mid: "native_" + new Date().getTime()
        };
        showMoreMessage(_sysMsg2, true);
        return;
      }

      resolveFileInput(event, files, {
        msgtype: "file",
        title: file.name,
        size: file.size,
        ackid: "msg_" + messageLength++
      }, true);
    }
  };
  document.getElementById("textarea").onkeydown = function (e) {
    markConsultingTabActive("textarea_keydown");
    var ev = document.all ? window.event : e;
    if (ev.keyCode == 13 && !event.shiftKey) {
      event.preventDefault();
      sendTextArea();
    }
  };
  document.getElementById("textarea").onfocus = function () {
    markConsultingTabActive("textarea_focus");
  };
  if (_utils2.default.isUCBrowser) {
    document.getElementById("pic-input").onchange = function (event) {
      markConsultingTabActive("select_picture");
      resolveSend(event);
    };
    document.getElementById("file-input").onchange = function (event) {
      markConsultingTabActive("select_file");
      resolveSend(event);
    };
    document.getElementById("video-btn").onchange = function (event) {
      markConsultingTabActive("select_video");
      resolveSend(event);
    };
  } else {
    document.getElementById("pic-input").oninput = function (event) {
      markConsultingTabActive("select_picture");
      resolveSend(event);
    };
    document.getElementById("file-input").oninput = function (event) {
      markConsultingTabActive("select_file");
      resolveSend(event);
    };
    document.getElementById("video-btn").oninput = function (event) {
      markConsultingTabActive("select_video");
      resolveSend(event);
    };
  }
  document.getElementById("drop-wrap").ondragover = function (event) {
    event.preventDefault();
    this.classList.add('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "block";
    document.getElementById('msg-wrapper').style.zIndex = -1;
    document.getElementsByClassName('footer')[0].style.zIndex = -1;
  };
  document.getElementById("drop-wrap").ondragleave = function (event) {
    event.preventDefault();
    this.classList.remove('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "none";
  };
  document.getElementById("drop-wrap").onmouseover = function (event) {
    document.getElementById('msg-wrapper').style.zIndex = '';
    document.getElementsByClassName("footer")[0].style.zIndex = '';
  };
  document.getElementById("drop-wrap").ondrop = function (event) {
    markConsultingTabActive("drop_file");
    event.preventDefault();
    this.classList.remove('drop-css');
    document.getElementsByClassName("drop-div-bg")[0].style.display = "none";
    document.getElementById('msg-wrapper').style.zIndex = '';
    document.getElementsByClassName("footer")[0].style.zIndex = '';
    var files = event.dataTransfer.files;

    var count = 0;
    for (var i in files) {
      if ((0, _typeof3.default)(files[i]) !== 'object') {
        continue;
      }
      count++;
      var file = files[i];

      if (_utils2.default.isImageFile(file.name)) {
        // 图片限制10M - 提前检查
        if (file.size > 10 * 1024 * 1024) {
          var sysMsg = {
            msgtype: "system",
            content: "图片的大小不能超过10M！",
            mid: "native_" + new Date().getTime()
          };
          showMoreMessage(sysMsg, true);
          return;
        }

        resolveFileInput(event, files, {
          content: pic_uploading,
          msgtype: "image",
          ackid: "msg_" + messageLength++
        });
      } else if (_utils2.default.isVideoFile(file.name)) {
        // 处理视频发送
        if (file) {
          if (file.size > 25 * 1024 * 1024) {
            var _sysMsg3 = {
              msgtype: "system",
              content: "视频的大小不能超过25M！",
              mid: "native_" + new Date().getTime()
            };
            showMoreMessage(_sysMsg3, true);
            return;
          }
          if (_utils2.default.isWindowsPC) {
            handleVideoBg(file, event, files);
          } else {
            resolveFileInput(event, files, {
              msgtype: "video",
              content: '',
              thumb: '',
              width: 0,
              height: 0,
              duration: 0,
              size: '',
              ackid: "msg_" + messageLength++
            });
          }
        }
      } else {
        // 文件限制25M - 提前检查
        if (file.size > 25 * 1024 * 1024) {
          var _sysMsg4 = {
            msgtype: "system",
            content: "文件的大小不能超过25M！",
            mid: "native_" + new Date().getTime()
          };
          showMoreMessage(_sysMsg4, true);
          return;
        }

        resolveFileInput(event, files, {
          msgtype: "file",
          title: file.name,
          size: file.size,
          ackid: "msg_" + messageLength++
        }, true);
      }
      if (count === 5) {
        return;
      }
    }
  };
  document.addEventListener("paste", function (event) {
    markConsultingTabActive("paste");
    // https://www.jb51.net/article/80657.htm
    if (event.clipboardData || event.originalEvent) {
      //not for ie11  某些chrome版本使用的是event.originalEvent
      var clipboardData = event.clipboardData || event.originalEvent.clipboardData;
      if (clipboardData.items) {
        // for chrome
        var items = clipboardData.items;
        var blob = void 0;
        //在items里找粘贴的image,据上面分析,需要循环
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            //getAsFile() 此方法只是living standard firefox ie11 并不支持
            blob = items[i].getAsFile();
          }
        }
        if (blob) {
          event.preventDefault();

          var file = event.clipboardData.files[0];

          // 粘贴图片限制10M - 提前检查
          if (file.size > 10 * 1024 * 1024) {
            var sysMsg = {
              msgtype: "system",
              content: "图片的大小不能超过10M！",
              mid: "native_" + new Date().getTime()
            };
            showMoreMessage(sysMsg, true);
            return;
          }

          if (window.FileReader) {
            var reader = new FileReader();
            reader.readAsDataURL(file); //必须加此项 否则onload无法执行
            reader.onload = function (event) {
              // event.target.result 即为图片的Base64编码字符串
              var imgData = event.target.result;
              _utils2.default.changePromoteDialog({
                content: "<img style=\"max-height:24rem; max-width:100%\"  src=" + imgData + " />",
                cb: function cb() {
                  resolveFileInput(event, { blob: blob }, {
                    content: pic_uploading,
                    msgtype: "image",
                    ackid: "msg_" + messageLength++
                  }, false, true);
                }
              });
            };
          } else {
            //不支持FileReader 的粘贴直接发出
            resolveFileInput(event, { blob: blob }, {
              content: pic_uploading,
              msgtype: "image",
              ackid: "msg_" + messageLength++
            }, false, true);
          }
        }
      }
    }
  });
};

var messageReceived = function messageReceived(data) {
  var messageMid = getReadMessageId(data);
  if (messageMid && (isMessageMidRemembered(messageMid) || getMessageElementByMid(messageMid))) {
    return;
  }
  var shouldStickToBottom = isChatPanelOpen() && isNearMessageBottom();
  var html = createMessageHtml(data, { createNode: true, readSource: "realtime" });
  var element = document.getElementById("msg-wrapper");
  element.appendChild(html);
  if (shouldStickToBottom) {
    _utils2.default.scrollDownEnd(undefined, 0);
    setNewMessageHintVisible(false);
    scheduleReadReceiptCheck(350);
  } else if (isChatPanelOpen() && data && data.uid != data.from_uid) {
    setNewMessageHintVisible(true);
  }
  startNotification(data);
};

var startNotification = function startNotification(data) {
  var iFrameState = _shelltool2.default.getifameState();
  if (loginData.config_data.notify_style == "auto_expand") {
    if (data.from_uid == data.uid) {
      return;
    }
    if (!iFrameState) {
      _shelltool2.default.postMessage({ type: "spread" });
      _shelltool2.default.setiFrameState(0);
    }
  } else if (!iFrameState) {
    _shelltool2.default.postMessage({ type: "redDot" });
  }
  if (!loginData.config_data.notify_is_voice) {
    return;
  }
  var visibile = document.visibilityState;
  if (visibile == undefined) {
    visibile = document.webkitHidden;
  }
  if (visibile == undefined) {
    visibile = document.hidden;
  }
  if (visibile == "visible" && iFrameState) {
    return;
  }
  var audio = document.getElementById("audio") || document.querySelector("audio");
  if (_utils2.default.IsIOS) {
    // 处理IOS上音频播放报错问题
    audio.onclick = function () {
      audio.play();
    };
    audio.click();
  } else {
    audio.onclick = function () {
      audio.play();
    };
  }
};
// 获取访客归属地信息
// 使用IPIP.net接口获取归属地 (支持CORS)
var getLocationFromIpip = function getLocationFromIpip() {
  return new _promise2.default(function (resolve) {
    var controller = new AbortController();
    var timeout = setTimeout(function () {
      controller.abort();
      resolve('');
    }, 2000);

    fetch('https://myip.ipip.net/json', {
      signal: controller.signal
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      clearTimeout(timeout);
      if (data && data.ret === 'ok' && data.data) {
        var ip = data.data.ip || '';
        var loc = data.data.location;

        if (loc && loc.length > 0) {
          // location: ["中国", "湖北", "武汉", "", "联通"]
          var country = loc[0] || '';
          var province = loc[1] || '';
          var city = loc[2] || '';
          var isp = loc[4] || '';

          // 国外直接显示国家
          if (country !== '中国') {
            resolve(country || ip);
            return;
          }

          // 直接拼接省市，不加"省"和"市"后缀
          var locationStr = province + (city && city !== province ? city : '');
          var addr = (locationStr + (isp ? ' ' + isp : '')).trim();
          resolve(addr || ip);
        } else {
          // 没有 location 信息，返回 IP
          resolve(ip);
        }
      } else {
        resolve('');
      }
    }).catch(function () {
      clearTimeout(timeout);
      resolve('');
    });
  });
};

// 使用又拍云接口获取归属地 (备用)
var getLocationFromUpyun = function getLocationFromUpyun() {
  return new _promise2.default(function (resolve) {
    fetch("http://pubstatic.b0.upaiyun.com/?_upnode&r=" + Date.now()).then(function (res) {
      return res.json();
    }).then(function (data) {
      var ip = data && data.remote_addr || '';
      var loc = data && data.remote_addr_location;
      if (loc) {
        // 国内：拼接省市，国外：显示国家
        if (loc.country === '中国') {
          // 直接拼接省市，不加"省"和"市"后缀
          var locationStr = loc.province + (loc.city && loc.city !== loc.province ? loc.city : '');
          var isp = loc.isp || '';
          var location = (locationStr + (isp ? ' ' + isp : '')).trim();
          resolve(location || ip);
        } else {
          resolve(loc.country || ip);
        }
      } else {
        // 没有 location 信息，返回 IP
        resolve(ip);
      }
    }).catch(function () {
      return resolve('');
    });
  });
};

// 获取访客归属地信息（带备用机制）
var getVisitorLocation = function getVisitorLocation() {
  return new _promise2.default(function (resolve) {
    var timeout = setTimeout(function () {
      resolve('');
    }, 2000);

    // 先尝试IPIP.net接口
    getLocationFromIpip().then(function (location) {
      if (location) {
        clearTimeout(timeout);
        resolve(location);
        return; // IPIP成功，不调用备用接口
      }
      // IPIP失败，尝试又拍云备用接口
      getLocationFromUpyun().then(function (fallbackLocation) {
        clearTimeout(timeout);
        resolve(fallbackLocation);
      });
    });
  });
};

var resolveLogin = function resolveLogin(cb, failCb) {
  if (window._ZHINI_CACHED_TOKEN && window._ZHINI_CACHED_CONFIG_DATA) {
    loginData.token = window._ZHINI_CACHED_TOKEN;
    window._ZHINI_CONFIG_DATA = window._ZHINI_CACHED_CONFIG_DATA;
    loginData.config_data = handleOrginalData(window._ZHINI_CONFIG_DATA);
    loginData.kefu_name_from = loginData.config_data[_utils2.default.IsPcMode ? "kefu_name" : "mobile_kefu_name"];
    cb();
    return;
  }

  delete urlParams.t;
  urlParams.version = "0.1.3";
  urlParams.adddomain = true;

  // 【关键】优先使用 SDK 传递的 client_id（用户配置的或系统生成的）
  var latestClientId = window._ZHINI_INIT_CLIENT_ID;

  // 如果 SDK 没有传递，则从 localStorage 获取
  if (!latestClientId) {
    latestClientId = localStorage.getItem('zhini_init_client_id_' + urlParams.channel_id) || localStorage.getItem('zhini_client_id_' + urlParams.channel_id);
  }

  if (latestClientId) {
    urlParams.client_id = latestClientId;
  }
  applyInitUserParams(urlParams);

  var MAX_NEWLOGIN_RETRY_COUNT = 3;
  var NEWLOGIN_RETRY_DELAY = 2000;
  var showNewloginNetworkError = function showNewloginNetworkError() {
    var sysMsg = {
      msgtype: "system",
      content: "网络异常连接已断开，请刷新页面重连！",
      mid: "native_" + new Date().getTime()
    };
    showMoreMessage(sysMsg, true);
  };
  var isNetworkRetryableError = function isNetworkRetryableError(error, status) {
    if (!window.navigator.onLine) {
      return true;
    }
    if (status === 0) {
      return true;
    }
    if (!error) {
      return true;
    }
    if (typeof error === "string") {
      return error.trim() === "";
    }
    return false;
  };
  var sendNewloginRequest = function sendNewloginRequest(retryCount) {
    _ajaxutils2.default.httpRequest({
      url: '/wykf/api/v1/enterprise/webplugin/newlogin?version=' + encodeURIComponent(urlParams.version),
      type: "POST",
      contentType: "application/json; charset=UTF-8",
      data: buildNewloginRequestData(),
      success: function success(result) {
        if (result.sta !== 0) {
          if (result.errcode === 10003) {
            window._ZHINI_CACHED_TOKEN = null;
            window._ZHINI_CACHED_CONFIG_DATA = null;
          }
          failCb && failCb(result);
          return;
        }

        var data = result.data;
        loginData.token = data.token;
        syncLastReportedReadMid(data);

        window._ZHINI_CACHED_TOKEN = data.token;
        if (data.config_data) {
          window._ZHINI_CACHED_CONFIG_DATA = data.config_data;
        }

        if (data.config_data) {
          window._ZHINI_CONFIG_DATA = data.config_data;
        }

        loginData.config_data = handleOrginalData(data.config_data);

        if (data.config_data) {
          initStyles();
        }

        loginData.kefu_name_from = loginData.config_data[_utils2.default.IsPcMode ? "kefu_name" : "mobile_kefu_name"];
        document.getElementById("profile").innerHTML = _utils2.default.replaceAll(loginData.config_data.customized_info, "<p></p>", "<p><br/></p>");
        _shelltool2.default.postMessage({ type: "showBtn", data: window._ZHINI_CONFIG_DATA }, 100);
        window.requestHis = false;
        cb();
      },
      error: function error(_error2, status) {
        var zhiniAdNode = document.getElementsByClassName("agent-advertise")[0];
        if (zhiniAdNode) {
          zhiniAdNode.style.display = 'none';
        }
        if (isNetworkRetryableError(_error2, status) && retryCount < MAX_NEWLOGIN_RETRY_COUNT) {
          setTimeout(function () {
            sendNewloginRequest(retryCount + 1);
          }, NEWLOGIN_RETRY_DELAY);
          return;
        }
        if (isNetworkRetryableError(_error2, status)) {
          showNewloginNetworkError();
        }
        failCb && failCb(_error2);
      }
    });
  };

  getVisitorLocation().then(function (location) {
    urlParams.location = location || '';
    sendNewloginRequest(0);
  }).catch(function (err) {
    failCb && failCb(err);
  });
};

// 把新接口数据转化为原始数据
var handleOrginalData = function handleOrginalData(configData) {

  // 安全获取嵌套属性
  var safeGet = function safeGet(obj, path, defaultVal) {
    if (!obj) return defaultVal;
    return path.split('.').reduce(function (o, k) {
      return o && o[k] !== undefined ? o[k] : defaultVal;
    }, obj);
  };

  var pc = configData ? configData.pc || {} : {};
  var mobile = configData ? configData.mobile || {} : {};
  var notify = configData ? configData.notify || {} : {};

  var data = {
    button_color: safeGet(pc, 'menubar.button_style.color', '#4A90E2'),
    button_content: safeGet(pc, 'menubar.buttons', []),
    button_position: safeGet(pc, 'menubar.button_style.horizontal', 'right'),
    button_style: safeGet(pc, 'menubar.button_style.shape', 'round'),
    vertical: safeGet(pc, 'menubar.button_style.vertical', ''),

    customized_info: safeGet(pc, 'chatbox.window_config.right_sidebar_content', ''),
    title: safeGet(pc, 'chatbox.window_config.title', '在线客服'),
    form_color: safeGet(pc, 'chatbox.window_style.color', '#ffffff'),
    form_position: safeGet(pc, 'chatbox.window_style.horizontal', 'right'),
    form_style: pc.chatbox && pc.chatbox.type == 1 ? 'customized' : 'normal',
    head_img: safeGet(pc, 'chatbox.window_config.avatar', ''),
    kefu_name: safeGet(pc, 'chatbox.window_config.nickname', '客服'),
    show_enable_ad: safeGet(pc, 'chatbox.window_config.enable_ad', false),

    mobile_button_color: safeGet(mobile, 'menubar.button_style.color', '#4A90E2'),
    mobile_button_content: safeGet(mobile, 'menubar.buttons', []),
    mobile_button_position: safeGet(mobile, 'menubar.button_style.horizontal', 'right'),
    mobile_button_style: safeGet(mobile, 'menubar.button_style.shape', 'round'),
    mobile_vertical: safeGet(mobile, 'menubar.button_style.vertical', ''),

    mobile_form_color: safeGet(mobile, 'chatbox.window_style.color', '#ffffff'),
    mobile_form_style: mobile.chatbox && mobile.chatbox.type == 1 ? 'full_screen' : 'half_screen',
    mobile_head_img: safeGet(mobile, 'chatbox.window_config.avatar', ''),
    mobile_kefu_name: safeGet(mobile, 'chatbox.window_config.nickname', '客服'),
    mobile_title: safeGet(mobile, 'chatbox.window_config.title', '在线客服'),
    mobile_show_enable_ad: safeGet(mobile, 'chatbox.window_config.enable_ad', false),

    notify_is_voice: notify ? notify.open_voice : false,
    notify_style: notify ? notify.style : 'banner'

    //兼容旧数据
  };if (typeof data.button_content == 'string' || !data.button_content) {
    data.button_content = [{
      type: 'chatbox',
      title: data.button_content || '客服在线，点击咨询',
      icon_source_type: 0,
      icon_img_url: '',
      status: 1,
      system_icon_type: 0
    }];
  }

  if (typeof data.mobile_button_content == 'string' || !data.mobile_button_content) {
    data.button_content = [{
      type: 'chatbox',
      title: data.button_content || '客服在线，点击咨询',
      icon_source_type: 0,
      icon_img_url: '',
      status: 1,
      system_icon_type: 0
    }];
  }

  if (data.button_position == 'rightCenter') {
    data.button_position = 'right';
    data.vertical = '50%';
  }
  if (data.button_position == 'leftCenter') {
    data.button_position = 'left';
    data.vertical = '50%';
  }
  if (data.mobile_button_position == 'rightCenter') {
    data.mobile_button_position = 'right';
    data.mobile_vertical = '50%';
  }

  if (data.mobile_button_position == 'leftCenter') {
    data.mobile_button_position = 'left';
    data.mobile_vertical = '50%';
  }
  return data;
};
var initContents = function initContents() {
  var config_data = loginData.config_data;
  var pcMode = _utils2.default.IsPcMode;
  var titleNode = document.getElementsByClassName("agent-info")[0];
  titleNode.innerHTML = config_data[pcMode ? "title" : "mobile_title"] || "";
  var headImgNode = document.getElementsByClassName("agent-avatar")[0];
  var headImgSrc = config_data[pcMode ? "head_img" : "mobile_head_img"];
  var headAdShow = config_data[pcMode ? "show_enable_ad" : "mobile_show_enable_ad"];
  if (headImgSrc) {
    headImgNode.src = headImgSrc;
    headImgNode.style.display = "block";
  } else {
    titleNode.style.marginLeft = "16px";
  }
  var zhiniAdNode = document.getElementsByClassName("agent-advertise")[0];
  if (Number(headAdShow) === 0) {
    if (pcMode) {
      titleNode.style.height = '60px';
      titleNode.style.lineHeight = '60px';
      zhiniAdNode.style.display = 'none';
    } else {
      titleNode.style.height = '60px';
      titleNode.style.lineHeight = '60px';
      zhiniAdNode.style.display = 'none';
    }
  }
};

var initStyles = function initStyles() {
  var config_data = loginData.config_data;

  if (!config_data) {
    return;
  }

  // 【重要】移除旧的样式标签，避免重复
  var oldStyle = document.getElementById('zhini-dynamic-styles');
  if (oldStyle) {
    oldStyle.remove();
  }

  var styleNode = document.createElement("style");
  styleNode.id = 'zhini-dynamic-styles';
  styleNode.setAttribute("type", "text/css");
  var formColor = config_data[_utils2.default.IsPcMode ? "form_color" : "mobile_form_color"];

  // 检查颜色是否有效（不是白色默认值才覆盖样式）
  var isValidColor = formColor && formColor !== '#ffffff' && formColor !== '#fff' && formColor !== 'ffffff';

  // 构建样式内容
  var styleContent = '';
  if (isValidColor) {
    styleContent = "\n    .chat-header {\n      background: " + formColor + " !important;\n    }\n    .body-left .footer .text-holder #send-btn {\n      background: " + formColor + " !important;\n    }\n    .message-item.message-right .message-text {\n      background: " + formColor + " !important;\n      color: #fff !important;\n    }";
  }

  if (config_data.form_style == "normal" || !_utils2.default.IsPcMode) {
    styleContent += '.body-right{display: none !important;}.chat-body{padding-right: 0 !important;}';
  };

  if (styleNode.styleSheet) {
    styleNode.styleSheet.cssText = styleContent;
  } else {
    styleNode.appendChild(document.createTextNode(styleContent));
  }
  document.head.appendChild(styleNode);

  // 样式注入完成后，通知外层插件
  window.parent.postMessage({ type: 'zhini-styles-ready' }, '*');
};

// 暴露触发函数给 shelltool.js 调用
window.triggerInitStyles = function () {
  // 重新从 window._ZHINI_CONFIG_DATA 读取配置（确保使用最新的）
  if (window._ZHINI_CONFIG_DATA) {
    loginData.config_data = handleOrginalData(window._ZHINI_CONFIG_DATA);
  }

  initStyles();
};

var messageLength = 0;
var lastMid = "";
var loginData = {};
var urlParams = _utils2.default.getAllparams();
// 添加防重复标志
var isContentStartProcessing = false;
var hasContentStarted = false;
var activeTabReconnectRetryTimer = null;

var reconnectActiveTabWithToken = function reconnectActiveTabWithToken(params) {
  var reconnectToken = params && (params.token || loginData.token || window._ZHINI_CACHED_TOKEN);
  if (!reconnectToken) {
    return false;
  }
  loginData.token = reconnectToken;
  var reconnectParams = (0, _assign2.default)({}, params);
  if (!isChatPanelOpen()) {
    // 隐藏聊天窗口时只恢复 WebSocket，不让 onopen 触发 message 历史接口。
    delete reconnectParams.type;
  }
  // 多 Tab 恢复只复用现有 token 重建 WebSocket，不重新执行登录流程。
  _wsUtils2.default.startProcess("init", {
    messageReceived: messageReceived,
    token: reconnectToken,
    params: reconnectParams
  });
  return true;
};

var startProcess = function startProcess(params) {
  if (params && params.activeTabReconnect) {
    if (params.token) {
      loginData.token = params.token;
    }
    if (isContentStartProcessing) {
      if (activeTabReconnectRetryTimer) {
        return;
      }
      activeTabReconnectRetryTimer = setTimeout(function () {
        activeTabReconnectRetryTimer = null;
        startProcess(params);
      }, 500);
      return;
    }
    if (isChatPanelOpen() && _wsUtils2.default.isWsAvailable()) {
      requestMessageList(undefined, undefined, { showRecoveryMessage: false });
      return;
    }
    reconnectActiveTabWithToken(params);
    return;
  }

  // 防重复检查
  if (isContentStartProcessing) {
    if (params && params.errcode === 10003) {
      setTimeout(function () {
        startProcess(params);
      }, 500);
    }
    return;
  }

  if (hasContentStarted && !params) {
    return;
  }

  // 设置处理标志
  isContentStartProcessing = true;

  if (params && params.errcode === 10003) {
    _wsUtils2.default.startProcess("closeWsPingEvent", params);
    // 重置标志，允许重新初始化
    hasContentStarted = false;
    // 【重要】清除内存缓存，让 resolveLogin 重新调用 newlogin
    window._ZHINI_CACHED_TOKEN = null;
    window._ZHINI_CACHED_CONFIG_DATA = null;
  }

  var finishStartProcess = function finishStartProcess(started) {
    hasContentStarted = !!started;
    isContentStartProcessing = false;
  };

  resolveLogin(function () {
    _wsUtils2.default.startProcess("init", {
      messageReceived: messageReceived,
      token: loginData.token,
      params: params
    });
    // initStyles() 不再在这里调用，改为由 shelltool.js 收到 init 消息后触发
    initContents();
    initEmojiFunction();
    initActions();
    initReadReceiptWatcher();
    finishStartProcess(true);
  }, function () {
    finishStartProcess(false);
  });
};
exports.default = {
  startProcess: startProcess,
  showMoreMessage: showMoreMessage,
  requestMessageList: requestMessageList
};

/***/ }),

/***/ "GEX2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _ajaxutils = __webpack_require__("q+s0");

var _ajaxutils2 = _interopRequireDefault(_ajaxutils);

var _utils = __webpack_require__("mF0L");

var _utils2 = _interopRequireDefault(_utils);

var _content = __webpack_require__("9JCF");

var _content2 = _interopRequireDefault(_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wsController = function () {
  var reconnectCount = 0; // 重连计数器
  var firstReconnectTime = new Date().getTime(); // 首次重连时间
  var WS_ACTIVE_TIMEOUT = 10000;
  var TAB_ID = new Date().getTime() + "_" + Math.random().toString(16).slice(2);
  var CONSULTING_ACTIVE_TTL = 20000;
  var CONSULTING_HEARTBEAT_INTERVAL = 5000;
  var tabPriorityChannel = null;
  var tabPriorityChannelName = "";
  var consultingActive = false;
  var consultingActiveAt = 0;
  var consultingHeartbeatTimer = null;
  var suspendedByActiveConsultingTab = false;
  var activeConsultingTabId = "";
  var activeConsultingExpiresAt = 0;
  var activeTabReconnectTimer = null;

  // 页面级状态随当前页面生命周期存在，刷新或新开 Tab 时都会重新初始化。
  var getPageConnectionState = function getPageConnectionState() {
    if (!window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__) {
      window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__ = {
        wsOpened: false,
        initialMessageListLoaded: false
      };
    }
    return window.__ZHINI_WEB_PLUGIN_PAGE_CONNECTION_STATE__;
  };

  var getChannelId = function getChannelId() {
    return _utils2.default.getParameterByName("channel_id") || localStorage.getItem("zhini_channel_id") || "";
  };
  var getClientId = function getClientId() {
    var channelId = getChannelId();
    return _utils2.default.getParameterByName("init_client_id_" + channelId) || _utils2.default.getParameterByName("client_id_" + channelId) || localStorage.getItem("zhini_init_client_id_" + channelId) || localStorage.getItem("zhini_client_id_" + channelId) || "";
  };
  var getPriorityStorageKey = function getPriorityStorageKey() {
    return "zhini_active_consulting_tab_" + getChannelId() + "_" + getClientId();
  };
  var getPriorityChannelName = function getPriorityChannelName() {
    return "zhini_ws_priority_" + getChannelId() + "_" + (getClientId() || "anonymous");
  };
  var getStoredActiveConsultingTab = function getStoredActiveConsultingTab() {
    try {
      return JSON.parse(localStorage.getItem(getPriorityStorageKey()) || "{}");
    } catch (e) {
      return {};
    }
  };
  var storeActiveConsultingTab = function storeActiveConsultingTab(payload) {
    try {
      localStorage.setItem(getPriorityStorageKey(), (0, _stringify2.default)(payload));
      localStorage.setItem(getPriorityStorageKey() + "_event", (0, _stringify2.default)((0, _assign2.default)({ eventTime: new Date().getTime() }, payload)));
    } catch (e) {}
  };
  var postTabPriorityMessage = function postTabPriorityMessage(payload) {
    var message = (0, _assign2.default)({ source: "zhini_ws_priority", tabId: TAB_ID }, payload);
    if (tabPriorityChannel) {
      tabPriorityChannel.postMessage(message);
    }
    storeActiveConsultingTab(message);
  };
  var closeWsForTabPriority = function closeWsForTabPriority() {
    var ws = resetConfig.ws;
    if (!ws) {
      return;
    }
    try {
      ws.nativeError = "tab_priority";
      ws.onclose = ws.onerror = ws.onmessage = ws.onopen = function () {};
      ws.close && ws.close();
    } catch (e) {}
    resetConfig.ws = undefined;
    resetConfig.lastActiveTime = 0;
  };
  var stopPing = function stopPing() {
    if (resetConfig.pingInterval) {
      clearInterval(resetConfig.pingInterval);
      resetConfig.pingInterval = null;
    }
  };
  var suspendForActiveConsultingTab = function suspendForActiveConsultingTab(message) {
    if (!message || message.tabId === TAB_ID) {
      return;
    }
    var now = new Date().getTime();
    if (!message.expiresAt || message.expiresAt <= now) {
      return;
    }
    if (consultingActive && consultingActiveAt >= (message.activeAt || 0)) {
      announceConsultingActive("keep_active");
      return;
    }
    if (consultingActive) {
      consultingActive = false;
      if (consultingHeartbeatTimer) {
        clearInterval(consultingHeartbeatTimer);
        consultingHeartbeatTimer = null;
      }
    }
    activeConsultingTabId = message.tabId;
    activeConsultingExpiresAt = message.expiresAt;
    suspendedByActiveConsultingTab = true;
    closeWsForTabPriority();
    stopPing();
  };
  var releaseActiveConsultingTab = function releaseActiveConsultingTab(message) {
    if (!message || message.tabId !== activeConsultingTabId) {
      return;
    }
    activeConsultingTabId = "";
    activeConsultingExpiresAt = 0;
    suspendedByActiveConsultingTab = false;
  };
  var handleTabPriorityMessage = function handleTabPriorityMessage(message) {
    if (!message || message.source !== "zhini_ws_priority" || message.tabId === TAB_ID) {
      return;
    }
    if (message.type === "consulting_active") {
      suspendForActiveConsultingTab(message);
    }
    if (message.type === "consulting_inactive") {
      releaseActiveConsultingTab(message);
    }
  };
  var initTabPriorityChannel = function initTabPriorityChannel() {
    var nextChannelName = getPriorityChannelName();
    if (tabPriorityChannelName === nextChannelName) {
      return;
    }
    tabPriorityChannelName = nextChannelName;
    if (tabPriorityChannel && tabPriorityChannel.close) {
      try {
        tabPriorityChannel.close();
      } catch (e) {}
    }
    tabPriorityChannel = null;
    if (window.BroadcastChannel) {
      tabPriorityChannel = new BroadcastChannel(tabPriorityChannelName);
      tabPriorityChannel.onmessage = function (event) {
        return handleTabPriorityMessage(event.data);
      };
    }
    var stored = getStoredActiveConsultingTab();
    suspendForActiveConsultingTab(stored);
  };
  window.addEventListener("storage", function (event) {
    if (!event.key || event.key !== getPriorityStorageKey() + "_event" || !event.newValue) {
      return;
    }
    try {
      handleTabPriorityMessage(JSON.parse(event.newValue));
    } catch (e) {}
  });
  var announceConsultingActive = function announceConsultingActive(reason) {
    consultingActive = true;
    consultingActiveAt = new Date().getTime();
    suspendedByActiveConsultingTab = false;
    activeConsultingTabId = TAB_ID;
    activeConsultingExpiresAt = consultingActiveAt + CONSULTING_ACTIVE_TTL;
    initTabPriorityChannel();
    postTabPriorityMessage({
      type: "consulting_active",
      reason: reason,
      activeAt: consultingActiveAt,
      expiresAt: activeConsultingExpiresAt
    });
    if (!consultingHeartbeatTimer) {
      consultingHeartbeatTimer = setInterval(function () {
        if (consultingActive) {
          announceConsultingActive("heartbeat");
        }
      }, CONSULTING_HEARTBEAT_INTERVAL);
    }
  };
  var announceConsultingInactive = function announceConsultingInactive(reason) {
    if (!consultingActive) {
      return;
    }
    consultingActive = false;
    if (consultingHeartbeatTimer) {
      clearInterval(consultingHeartbeatTimer);
      consultingHeartbeatTimer = null;
    }
    postTabPriorityMessage({
      type: "consulting_inactive",
      reason: reason,
      activeAt: consultingActiveAt,
      expiresAt: new Date().getTime()
    });
  };
  var releaseConsultingOnPageExit = function releaseConsultingOnPageExit() {
    return announceConsultingInactive("page_exit");
  };
  window.addEventListener("pagehide", releaseConsultingOnPageExit);
  window.addEventListener("beforeunload", releaseConsultingOnPageExit);
  var hasValidActiveConsultingTab = function hasValidActiveConsultingTab() {
    if (!activeConsultingTabId || activeConsultingTabId === TAB_ID) {
      return false;
    }
    if (activeConsultingExpiresAt <= new Date().getTime()) {
      activeConsultingTabId = "";
      activeConsultingExpiresAt = 0;
      suspendedByActiveConsultingTab = false;
      return false;
    }
    return true;
  };
  var markWsActive = function markWsActive() {
    resetConfig.lastActiveTime = new Date().getTime();
  };
  var _isWsAvailable = function _isWsAvailable() {
    if (suspendedByActiveConsultingTab && hasValidActiveConsultingTab()) {
      return false;
    }
    var ws = resetConfig.ws;
    if (!ws) {
      return false;
    }
    if (ws.nativeError || ws.readyState !== WebSocket.OPEN) {
      return false;
    }
    return new Date().getTime() - resetConfig.lastActiveTime <= WS_ACTIVE_TIMEOUT;
  };
  var reconnectActiveConsultingTab = function reconnectActiveConsultingTab(params) {
    if (!consultingActive || !token) {
      return;
    }
    if (activeTabReconnectTimer) {
      clearTimeout(activeTabReconnectTimer);
    }
    activeTabReconnectTimer = setTimeout(function () {
      activeTabReconnectTimer = null;
      _content2.default.startProcess((0, _assign2.default)({}, params || {}, {
        errcode: 10003,
        token: token,
        type: "needMsgList",
        activeTabReconnect: true
      }));
    }, 300);
  };
  var wsClosed = function wsClosed(type) {
    var ws = resetConfig.ws;
    if (!ws || ws.nativeError == "auth") {
      return;
    }
    ws.nativeError = type;
    var shouldRecoverActiveTab = consultingActive && type !== "auth" && type !== "tab_priority";
    closeWsHandler(ws, { showMessage: !shouldRecoverActiveTab });
    if (shouldRecoverActiveTab) {
      resetConfig.ws = undefined;
      resetConfig.lastActiveTime = 0;
      reconnectActiveConsultingTab({ reason: "ws_closed" });
      return;
    }
    if (type == "error" || type == "auth") {
      return;
    }
    resetPingEvent();
  };
  var resolveAuth = function resolveAuth(data) {
    if (data.sta == 0) {
      // requestMessageList(); // 知你逻辑为此处刷新会话
      var list = resetConfig.msgWaiting;
      resetConfig.msgWaiting = [];
      var current = new Date().getTime();
      list.forEach(function (item) {
        current - item.createTime < 120000 && sendWs(item);
      });
    } else {
      wsClosed("auth");
      if (data.errcode == 4001 || data.errcode == 4003) {
        resetConfig.resetTimeWs = Number.MAX_VALUE;
      }
      if (!shouldReconnect()) {
        var sysMsg = {
          msgtype: "system",
          content: "连接已断开，请刷新页面重试！",
          mid: "native_" + new Date().getTime()
        };
        _content2.default.showMoreMessage(sysMsg, true);
      }
      if (data.data.errcode === 10003 && shouldReconnect()) {
        // websocket接收token过期重新登录
        _content2.default.startProcess({
          errcode: data.data.errcode,
          token: token,
          type: "needMsgList"
        });
        reconnectCount++; //重连次数增加
      }
    }
  };
  var onopen = function onopen(evt, params) {
    markWsActive();
    if (params && params.type === "needMsgList") {
      var isNetworkRecovery = params.reason === "ws_closed" || params.reason === "online";
      requestMessageList(undefined, undefined, {
        // Tab 切换重连保持静默，仅网络异常恢复时显示连接恢复提示。
        showRecoveryMessage: getPageConnectionState().wsOpened && isNetworkRecovery
      });
      getPageConnectionState().wsOpened = true;
    }
    _utils2.default.log("tkyj+++onopen+++" + (0, _stringify2.default)(evt.data));
    //this.setState({resetTime: 0});
  };
  var onclose = function onclose(evt) {
    _utils2.default.log("tkyj+++onclose+++" + evt.data);
    //this.setState({resetTime: 0});
    wsClosed();
  };
  var onerror = function onerror(evt) {
    _utils2.default.log("tkyj+++onerror+++" + evt.data);
    //this.setState({resetTime: 0});
    wsClosed("error");
  };
  var onmessage = function onmessage(evt) {
    var data = evt.data;
    if (!(typeof evt.data == "string")) {
      return;
    }
    data = JSON.parse(data || "{}");
    _utils2.default.log("tkyj++++onmessage++++" + (0, _stringify2.default)(data));
    switch (data.type) {
      case "auth":
        {
          resolveAuth(data);
          break;
        }
      case "pong":
        {
          markWsActive();
          resetConfig.pingCount = 0;
          break;
        }
      case "message":
        {
          markWsActive();
          if (data.data && actionCBs.messageReceived) {
            actionCBs.messageReceived(data.data);
          }
          break;
        }
      default:
        {
          break;
        }
    }
  };
  var sendWs = function sendWs(data) {
    var ws = resetConfig.ws;
    if (ws && ws.nativeError == "auth") {
      return;
    }
    _utils2.default.log("tkyj+++sendWs+++" + (0, _stringify2.default)(data));
    data.count = data.count == undefined ? 1 : data.count;
    try {
      if (!localStorage.wsNativeId) {
        localStorage.wsNativeId = Math.random();
      }
      data.message.wsNativeId = localStorage.wsNativeId;
      ws.send((0, _stringify2.default)(data.message));
    } catch (e) {
      _utils2.default.log("tkyj+++++tryresend++e++" + (0, _stringify2.default)(e));
      if (!data.count) {
        return;
      }
      data.count--;
      data.createTime = new Date().getTime();
      resetConfig.msgWaiting.push(data);
      if (data.message.type == "ping") {
        _utils2.default.log("tkyj+++++tryresend++resetWs+++++++");
        closeWsHandler(ws);
        resetWs(token);
      } else {
        _utils2.default.log("tkyj++tryresend++pingCount+++" + resetConfig.pingCount);
        resetPingEvent(1, true);
        // this.sendWs({message: {type: 'ping'}})
      }
    }
    return true;
  };
  var continuePing = function continuePing() {
    if (resetConfig.pingInterval) {
      return;
    }
    resetConfig.pingInterval = setInterval(function () {
      if (suspendedByActiveConsultingTab && hasValidActiveConsultingTab()) {
        return;
      }
      var data = { message: { type: "ping" }, count: 0 };
      resetConfig.pingCount++;
      _utils2.default.log("tkyj++++++++pingInterval+++++++" + resetConfig.pingCount);
      if (resetConfig.pingCount > MAX_PING_COUNT) {
        data.count = 1;
        resetConfig.pingCount = 0;
      }
      sendWs(data);
    }, 3000);
  };
  var closeWsHandler = function closeWsHandler(ws) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!ws) {
      return;
    }
    ws.wyFinished = true;
    ws.onclose = ws.onerror = ws.onmessage = ws.onopen = function () {};
    // resetConfig.ws = undefined;
    if (options.showMessage !== false) {
      showBreakConnect();
    }
  };
  var showBreakConnect = function showBreakConnect() {
    var sysMsg = {
      msgtype: "system",
      content: "连接已断开，请刷新页面重试！",
      mid: "native_" + new Date().getTime()
    };

    _content2.default.showMoreMessage(sysMsg, true);
  };
  var resetPingEvent = function resetPingEvent(value, rightNow) {
    resetConfig.pingCount = value || MAX_PING_COUNT;
    if (rightNow) {
      sendWs({ message: { type: "ping" } });
    }
  };
  var resetWs = function resetWs(token, params, force) {
    initTabPriorityChannel();
    if (suspendedByActiveConsultingTab && hasValidActiveConsultingTab() && !consultingActive) {
      return;
    }
    if (resetConfig.ws && !force) {
      return;
    }
    if (resetConfig.ws && force) {
      closeWsForTabPriority();
    }
    var currentTime = new Date().getTime();
    var lastTime = resetConfig.resetTimeWs;
    _utils2.default.log("tkyj+++resetWs+++lastTime+++" + lastTime);
    if (!force && currentTime - lastTime < 10000) {
      resetPingEvent();
      return;
    }
    _utils2.default.log("tkyj+++resetWs+++from+++" + token);
    resetConfig.resetTimeWs = currentTime;
    var ws = new WebSocket((_ajaxutils2.default.getTestDomain() ? "wss://msg.zhinikefu.com" : "wss://xmsg.h5bqb.top") + "/wykf/websocket/webplugin?version=0.1.3&token=" + token);
    ws.onopen = function (evt) {
      onopen(evt, params);
    };
    ws.onclose = function (evt) {
      onclose(evt);
    };
    ws.onerror = function (evt) {
      onerror(evt);
    };
    ws.onmessage = function (evt) {
      onmessage(evt);
    };
    resetConfig.ws = ws;
  };
  var MAX_PING_COUNT = 3;
  var resetConfig = {
    ws: undefined,
    resetTimeWs: 0,
    pingCount: 0,
    msgWaiting: [],
    lastActiveTime: 0,
    pingInterval: null
  };
  var ensureActiveTabWs = function ensureActiveTabWs(params) {
    if (!token) {
      return;
    }
    var ws = resetConfig.ws;
    var lastActiveTime = resetConfig.lastActiveTime || 0;
    var wsExpired = new Date().getTime() - lastActiveTime > WS_ACTIVE_TIMEOUT;
    var shouldCreateWs = !ws || ws.nativeError || ws.readyState !== WebSocket.OPEN || wsExpired;
    if (!shouldCreateWs) {
      return;
    }
    reconnectActiveConsultingTab(params);
  };
  var actionCBs = {};
  var token = "";
  window.addEventListener("online", function (e) {
    if (shouldReconnect()) {
      // 检查是否需要重连
      resetConfig.ws = undefined;
      setTimeout(function () {
        _content2.default.startProcess({
          errcode: 10003,
          token: token,
          type: "needMsgList",
          reason: "online"
        });
        reconnectCount++; //重连次数增加
      }, 1000);
    }
  });
  function shouldReconnect() {
    if (reconnectCount === 0) {
      // 首次重连
      firstReconnectTime = new Date().getTime();
      return true;
    }
    var currentTime = new Date().getTime();
    var timeDifference = (currentTime - firstReconnectTime) / (1000 * 60 * 60); // 当前与首次重连的时间间隔
    if (timeDifference > 1) {
      // 首次重连超过1小时，重置重连次数和首次重连时间
      reconnectCount = 0;
      firstReconnectTime = currentTime;
    }

    return reconnectCount < 10; // 检查重连次数是否超过10次
  }
  return {
    init: function init(params) {
      _utils2.default.log("tkyj+++++init+++++++++");
      initTabPriorityChannel();
      actionCBs.messageReceived = params.messageReceived;
      token = params.token;
      resetConfig.ws = undefined;
      resetConfig.lastActiveTime = 0;
      if (!(suspendedByActiveConsultingTab && hasValidActiveConsultingTab() && !consultingActive)) {
        resetWs(params.token, params.params);
        continuePing();
      }
    },
    isWsAvailable: function isWsAvailable() {
      return _isWsAvailable();
    },
    isCurrentConsultingActive: function isCurrentConsultingActive() {
      return consultingActive;
    },
    setConsultingActive: function setConsultingActive() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      initTabPriorityChannel();
      if (params.active) {
        announceConsultingActive(params.reason || "active");
        ensureActiveTabWs(params.params);
      } else {
        announceConsultingInactive(params.reason || "inactive");
      }
    },
    sendMsgH: function sendMsgH(params) {
      if (!token) {
        return;
      }
      var channel_id = _utils2.default.getParameterByName("channel_id");
      var client_id = _utils2.default.getParameterByName("init_client_id_" + channel_id) || _utils2.default.getParameterByName("client_id_" + channel_id);
      var add_params = "&channel_id=" + channel_id + "&client_id=" + client_id;
      _ajaxutils2.default.httpRequest({
        type: "POST",
        url: "/wykf/api/v1/enterprise/webplugin/message?version=0.1.3" + add_params,
        contentType: "application/json; charset=UTF-8", // 标准 JSON 头，body 本就是 JSON.stringify 的结果
        data: { token: token, data: params.message },
        success: function success(result) {
          _utils2.default.log("tkyj++sendMsgH+++result++++" + (0, _stringify2.default)(result));
          params.cb && params.cb(0, result.data);
        },
        error: function error(res) {
          if (res.sta === 10003 && params.message.msgtype === "open_chat") {
            // open_chat自动重试
            _content2.default.startProcess({
              errcode: res.sta,
              token: token,
              type: "needMsgList"
            });
            setTimeout(function () {
              startProcess("sendMsgH", params);
            }, 3000);
          } else {
            if (params.sendCount < 4) {
              //消息发送失败重试3次
              params.cb && params.cb(-1, { msg: res.msg, errcode: res.sta, token: token }, params.sendCount + 1);
            }
          }
        }
      });
    },
    closeWsPingEvent: function closeWsPingEvent(params) {
      if (params.errcode === 10003 && params.token) {
        clearInterval(resetConfig.pingInterval);
      }
      wsClosed();
    }
  };
}();
var startProcess = function startProcess(action, params) {
  wsController[action](params);
};
exports.default = {
  startProcess: startProcess,
  isWsAvailable: function isWsAvailable() {
    return wsController.isWsAvailable();
  },
  isCurrentConsultingActive: function isCurrentConsultingActive() {
    return wsController.isCurrentConsultingActive();
  }
};

/***/ }),

/***/ "hvFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link-style":"link-style","clear-both":"clear-both","single-line":"single-line","chat-page":"chat-page","chat-header":"chat-header","agent-avatar":"agent-avatar","agent-info":"agent-info","agent-advertise":"agent-advertise","btn-hide-chat":"btn-hide-chat","pull-right":"pull-right","chat-body":"chat-body","zhini-support":"zhini-support","drag-div":"drag-div","body-left":"body-left","footer":"footer","text-holder":"text-holder","textarea":"textarea","send-btn":"send-btn","feature-holder":"feature-holder","feature-btn":"feature-btn","emoji-btn":"emoji-btn","pic-btn":"pic-btn","video-btn":"video-btn","file-btn":"file-btn","body-right":"body-right","emoji-dialog":"emoji-dialog","wx-emo-img":"wx-emo-img","qq-emo-c":"qq-emo-c","profile":"profile","promote-dialog":"promote-dialog","dialog-mask":"dialog-mask","dialog-visible":"dialog-visible","bottom-btn":"bottom-btn","close-icon":"close-icon","dialog-head":"dialog-head","dialog-body":"dialog-body","scroll-body":"scroll-body","btn-normal":"btn-normal","ok-btn":"ok-btn","cancel-btn":"cancel-btn","drop-css":"drop-css","drop-div-bg":"drop-div-bg","video-play-btn":"video-play-btn","v-duration":"v-duration"};

/***/ }),

/***/ "lVK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("hvFc");

__webpack_require__("qj7u");

var _shelltool = __webpack_require__("tf+u");

var _shelltool2 = _interopRequireDefault(_shelltool);

var _parseWxEmo = __webpack_require__("yjLh");

var _parseWxEmo2 = _interopRequireDefault(_parseWxEmo);

var _content = __webpack_require__("9JCF");

var _content2 = _interopRequireDefault(_content);

var _utils = __webpack_require__("mF0L");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initApp = function initApp() {

    // Sentry.init({
    //   dsn: "https://adbce50847f8499e9c168d880af79568@sentry.weiyoubot.cn/8",
    //   integrations: [new Sentry.Integrations.BrowserTracing()],

    //   // Set tracesSampleRate to 1.0 to capture 100%
    //   // of transactions for performance monitoring.
    //   // We recommend adjusting this value in production
    //   tracesSampleRate: 1.0,
    // });

    window.winData = { sendWs: function sendWs() {}, resetTimeWs: 0 };
    _shelltool2.default.init();

    var currentRef = document.referrer;
    var hasStarted = false;

    //判断 1、访问网页的来源是包含public域名的
    if (currentRef.indexOf('zhiniplugin.h5bqb.top') > 0) {
        setTimeout(function () {
            var channel_id = _utils2.default.getParameterByName("channel_id");
            window.location.href = 'https://zhinikefu.com/?hmsr=wangyechajian&hmpl=illegal&channel_id=' + channel_id;
        }, 2000);
    } else {

        // 只监听 postMessage（srcdoc 模式）
        window.addEventListener('message', function (event) {

            var data = event.data;
            switch (data.type) {
                case 'init':
                    {

                        // 先设置环境信息到全局变量（供 ajaxutils 使用），无论是否 isHide
                        window._ZHINI_ENV = {
                            isLocalDev: data.isLocalDev || false,
                            baseUrl: data.baseUrl || ''
                        };

                        // 接收 postMessage 传递的参数
                        var shouldHideBtn = data.isHide; // 保存是否隐藏按钮的标志

                        // 启动应用（只启动一次）- 即使 isHide=true 也要启动，这样才能看到日志
                        if (!hasStarted && data.channel_id) {
                            // 先将参数存储到 localStorage
                            localStorage.setItem('zhini_channel_id', data.channel_id);

                            // 注意：client_id 是通过 postMessage 传递的，InnerWeb 收到后直接使用
                            // 不需要再保存到 localStorage

                            // 再启动应用
                            _content2.default.startProcess();
                            hasStarted = true;
                        }
                        break;
                    }
                case 'ping':
                    {
                        break;
                    }
                default:
                    break;
            }
        }, false);
    }
};
initApp();

/***/ }),

/***/ "mF0L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _aes = __webpack_require__("FQmK");

var _aes2 = _interopRequireDefault(_aes);

var _encUtf = __webpack_require__("Kt55");

var _encUtf2 = _interopRequireDefault(_encUtf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* 工具方法，不与功能相关 */
var ENABLE_LOG = localStorage.ZHINI_LOG_ENABLE_FLAG;
exports.default = {
  IsIOS: function () {
    if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      return true;
    } else {
      return false;
    }
  }(),
  IsIE: function () {
    if (!!window.ActiveXobject || "ActiveXObject" in window) {
      return true;
    } else {
      return false;
    }
  }(),
  IsIE11: function () {
    if (/Trident\/7\./.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  }(),
  IsPcMode: function () {
    var userAgentInfo = window.navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "Harmony"];
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        return false;
      }
    }
    return true;
  }(),
  IsWeiXin: function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  }(),
  isWindowsPC: function () {
    var userAgentInfo = window.navigator.userAgent;
    return (/Windows NT/.test(userAgentInfo)
    );
  }(),
  isUCBrowser: function () {
    var userAgentInfo = window.navigator.userAgent;
    return (/UBrowser/i.test(userAgentInfo)
    );
  }(),
  replaceAll: function replaceAll(stringOrg, s1, s2) {
    return stringOrg.replace(new RegExp(s1, "gm"), s2);
  },
  replaceTag: function replaceTag(msg) {
    return msg.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  },
  replaceSpecialTag: function replaceSpecialTag(msg) {
    return this.replaceAll(msg, '<style', '&lt;style').replace(/<\/style>/g, '&lt;/style&gt;').replace(/<iframe/g, '&lt;iframe').replace(/<\/iframe>/g, '&lt;/iframe&gt;').replace(/<script/g, '&lt;script').replace(/<\/script>/g, '&lt;/script&gt;');
  },

  getParameterByName: function getParameterByName(name) {
    // 优先从 localStorage 读取（srcdoc 模式）
    var storageKey = 'zhini_' + name;
    var storageValue = localStorage.getItem(storageKey);
    if (storageValue) {
      return storageValue;
    }

    // 降级：从 URL 读取（传统模式）
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  getAllparams: function getAllparams() {
    var url = window.location.href;
    var param = {};

    // 从 URL 读取参数（传统模式）
    if (url.indexOf("?") != -1) {
      url.split("?")[1].split(/[&#]/).forEach(function (param_str) {
        (function () {
          param[this[0]] = decodeURIComponent(this[1]);
        }).call(param_str.split("="));
      });
    }

    // 从 localStorage 读取参数（srcdoc 模式）
    // 如果 URL 中没有参数，尝试从 localStorage 读取
    if ((0, _keys2.default)(param).length === 0) {
      var channel_id = localStorage.getItem('zhini_channel_id');
      var client_id = localStorage.getItem('zhini_client_id');
      if (channel_id) param.channel_id = channel_id;
      if (client_id) param.client_id = client_id;
    }

    return param;
  },
  formatDate: function formatDate(date, fmt, utc) {
    fmt = fmt || "yyyy-mm-dd hh:MM:ss";
    var o = {
      "m+": date[utc ? "getUTCMonth" : "getMonth"]() + 1, //月份
      "d+": date[utc ? "getUTCDate" : "getDate"](), //日
      "h+": date[utc ? "getUTCHours" : "getHours"](), //小时
      "M+": date[utc ? "getUTCMinutes" : "getMinutes"](), //分
      "s+": date[utc ? "getUTCSeconds" : "getSeconds"](), //秒
      "q+": Math.floor((date[utc ? "getUTCMonth" : "getMonth"]() + 3) / 3), //季度
      S: date[utc ? "getUTCMilliseconds" : "getMilliseconds"]() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date[utc ? "getUTCFullYear" : "getFullYear"]() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }return fmt;
  },
  formatStorageSize: function formatStorageSize() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var fixedNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    if (value < 1024) {
      return value + "B";
    }
    value = value / 1024;
    if (value < 1024) {
      return value.toFixed(fixedNum) + "KB";
    }
    return (value / 1024).toFixed(fixedNum) + "MB";
  },
  scrollDownEnd: function scrollDownEnd(length, duration) {
    var element = document.getElementById("msg-wrapper");
    if (duration == 0) {
      element.scrollTop = length || 99999999999999;
    }
    setTimeout(function () {
      element.scrollTop = length || 99999999999999;
    }, duration || 300);
  },
  log: function log(msg) {
    ENABLE_LOG && console.log("ZHINI IFRAME LOG --- " + msg);
  },

  changePromoteDialog: function changePromoteDialog(params) {
    // 等待 DOM 加载完成
    if (document.readyState !== 'complete') {
      console.warn('[utils.changePromoteDialog] DOM not ready, waiting...');
      window.addEventListener('load', function () {
        utils.changePromoteDialog(params);
      }, { once: true });
      return;
    }

    var promoteDialog = document.querySelector('.promote-dialog');
    var dialogBody = document.querySelector('.dialog-body');
    var cancelBtn = document.querySelector('.cancel-btn');
    var okBtn = document.querySelector('.ok-btn');

    // 检查 DOM 元素是否存在
    if (!promoteDialog || !dialogBody) {
      return;
    }

    if (!params) {
      promoteDialog.style.display = 'none';
      return;
    }

    dialogBody.innerHTML = params.content;
    promoteDialog.style.display = 'block';

    if (cancelBtn) {
      cancelBtn.style.display = params.noCancel ? 'none' : '';
      cancelBtn.onclick = function () {
        promoteDialog.style.display = 'none';
      };
    }

    if (okBtn) {
      okBtn.onclick = function () {
        // 【关键】调用确定按钮的回调函数
        if (params.cb && typeof params.cb === 'function') {
          params.cb();
        }
        promoteDialog.style.display = 'none';
      };
    }
  },
  isImageFile: function isImageFile(fileName) {
    // 正则表达式，匹配常见的图片格式后缀
    var imageFormatsRegex = /\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i;

    // 使用正则表达式的 test 方法进行匹配
    if (imageFormatsRegex.test(fileName)) {
      return true;
    } else {
      return false;
    }
  },
  isVideoFile: function isVideoFile(fileName) {
    // 正则表达式，匹配常见的图片格式后缀
    var videoFormatsRegex = /\.(m4v|M4V|mp4|MP4|mov|MOV|wmv|WMV|mkv|WKV|webm|WEBM)$/i;

    // 使用正则表达式的 test 方法进行匹配
    if (videoFormatsRegex.test(fileName)) {
      return true;
    } else {
      return false;
    }
  },
  base64ToFile: function base64ToFile(base64, fileName) {
    // 将 base64 按照逗号分割，获取前缀和文件内容部分
    var data = base64.split(',');
    // 利用正则表达式从前缀中获取图片的类型信息（如 image/png、image/jpeg 等）
    var type = data[0].match(/:(.*?);/)[1];
    // 从图片的类型信息中获取具体的文件格式后缀（如 png、jpeg 等）
    var suffix = type.split('/')[1];
    // 使用 atob() 对 base64 数据进行解码，得到文件数据流（以字符串形式输出）
    var bstr = atob(data[1]);
    // 获取解码结果字符串的长度
    var n = bstr.length;
    // 创建一个与文件数据流字符串长度相同的 8 位无符号整型数组
    var u8arr = new Uint8Array(n);
    // 通过循环将整型数组的每个元素填充为解码结果字符串对应位置字符的 UTF-16 编码单元
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    // 利用 File 构造函数创建 File 对象
    var file = new File([u8arr], fileName + '.' + suffix, { type: type });

    return file;
  },
  hasUnclosedATag: function hasUnclosedATag(htmlString) {
    // 正则表达式匹配不完整的<a>标签，即没有</a>闭合的<a>标签
    var unclosedATagPattern = /<a\s+[^>]*[^>]$/;
    // 使用正则表达式测试字符串
    return unclosedATagPattern.test(htmlString);
  },
  linkifyText: function linkifyText(text) {
    text = text.replace(/<a\b([^>]*)>/gi, function (match, attrs) {
      if (/target\s*=/i.test(attrs)) {
        return match;
      }
      return '<a' + attrs + ' target="_blank">';
    });

    // 找出所有<a>标签的起始和结束位置
    var aTagRegex = /<a\b[^>]*>|<\/a>/g;
    var aTagPositions = [];
    var stack = 0; // 用于跟踪<a>标签的嵌套
    var match = void 0;
    // 收集所有<a>标签的位置
    while ((match = aTagRegex.exec(text)) !== null) {
      if (match[0].startsWith('<a')) {
        stack++;
      } else {
        stack--;
      }
      if (stack > 0) {
        aTagPositions.push({
          start: match.index,
          end: aTagRegex.lastIndex - 4 // -4 调整结束位置，排除</a>的长度
        });
      }
    }
    // 匹配所有潜在的URL
    var urlRegex = /\b(?:https?|ftp|file|gopher|news|nntp|telnet|rtsp|svn|git|ssh|imap|ircs?|irc|gopher|ws|wss|weixin|mailto|data):\/\/[^\s<>"`{}|^\u4e00-\u9fff;,，。；、(（）)]*[^\u4e00-\u9fff\s<>"`{}|^;,.，。；、(（）)]/g;
    var lastUrlMatchIndex = 0;

    // 替换URL为超链接，同时排除<a>标签内的URL
    var linkifiedText = text.replace(urlRegex, function (url, index) {
      // 检查当前URL是否在<a>标签内
      var insideATag = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(aTagPositions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _step.value,
              start = _step$value.start,
              end = _step$value.end;

          if (index > start && index <= end) {
            insideATag = true;
            break;
          }
        }
        // 如果不在<a>标签内，则替换为<a>标签
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!insideATag) {
        // 确保不会错误地截断已有的<a>标签
        var textSinceLastMatch = text.substring(lastUrlMatchIndex, index);
        var hasOpenATag = /<a\b/.test(textSinceLastMatch);
        var hasCloseATag = /\<\/a>/.test(textSinceLastMatch);
        if (hasOpenATag && !hasCloseATag) {
          // 如果在当前匹配的URL之前有打开的<a>标签但没有闭合，则不替换
          return url;
        }
        lastUrlMatchIndex = index + url.length;
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      }
      // 如果在<a>标签内或不需要替换，则保留原样
      return url;
    });

    return linkifiedText;
  },
  blobToBase64: function blobToBase64(blob) {
    return new _promise2.default(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        return resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  },

  // 计算文本的宽度
  calculateTextWidth: function calculateTextWidth(text) {
    var span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.innerText = text;
    document.body.appendChild(span);
    var width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
  },
  truncateFileName: function truncateFileName(fileName, containerWidth) {
    var ellipsis = '...';
    var fileNameWidth = this.calculateTextWidth(fileName); // 计算文件名的宽度

    if (fileNameWidth <= containerWidth) {
      return fileName; // 如果文件名宽度小于容器宽度，直接返回文件名
    }

    var endCharsLength = 12; // 保留的尾部字符长度
    var availableWidth = containerWidth - this.calculateTextWidth(ellipsis) - endCharsLength; // 可用宽度

    var start = '';
    var end = fileName;
    var truncatedFileName = '';

    // 从文件名的开头逐个字符添加，直到剩余宽度不足以容纳省略号和尾部字符
    for (var i = 0; i < fileName.length; i++) {
      start += fileName[i];
      end = fileName.slice(i + 1);
      if (this.calculateTextWidth(start + ellipsis + end.substring(end.length - endCharsLength)) > containerWidth) {
        break;
      }
      truncatedFileName = start + ellipsis + end.substring(end.length - endCharsLength);
    }

    return truncatedFileName;
  },
  hasSensitiveWords: function hasSensitiveWords(str) {
    if (str == '' || str == undefined) return false;
    str = str.replace(/\s+/g, '');
    var key = 'zhiniwebplugin';
    // const encrytedText = AES.encrypt(originText, key).toString(); //加密
    var encrytedWords = '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'; //密文
    var words = _aes2.default.decrypt(encrytedWords, key).toString(_encUtf2.default); //解密
    var array = words.split(','),
        len = array.length;
    for (var i = 0; i < len; i++) {
      var item = array[i];
      if (str.indexOf(item) >= 0 && item != '') {
        return item;
      }
    }
    return false;
  }
};

/***/ }),

/***/ "q+s0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _utils = __webpack_require__("mF0L");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyDomainParam = function applyDomainParam(params) {
  if (!params) {
    return params;
  }
  var domainurl = null;

  // 识别当前是否在本地开发环境
  var currentHost = window.location.host;
  var isLocal = currentHost.indexOf('localhost') === 0 || currentHost.indexOf('127.0.0.1') === 0 || currentHost.indexOf('192.168.') === 0;

  if (params.adddomain) {
    // 规则：本地开发环境不传 domain
    if (!isLocal) {
      // 优先级 1: 从 Referrer 获取 (适用于大部分 iframe 场景)
      if (document.referrer) {
        try {
          var refUrl = new URL(document.referrer);
          if (refUrl.origin && refUrl.origin !== 'null') {
            domainurl = refUrl.origin + '/';
          }
        } catch (e) {
          domainurl = document.referrer;
        }
      }

      // 优先级 2: 如果 Referrer 失败，尝试使用 ancestorOrigins (Chrome/Safari 兼容)
      if ((!domainurl || domainurl === 'null') && window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
        domainurl = window.location.ancestorOrigins[0] + '/';
      }

      // 优先级 3: 最后的兜底，使用 URL 参数中自带的 domain (如果有的话)
      if (!domainurl || domainurl === 'null') {
        domainurl = params.domain;
      }

      // 如果拿到了有效的域名，则设置它
      if (domainurl && domainurl !== 'null') {
        params.domain = domainurl;
      }
    } else {
      // 本地环境，强制移除 domain 参数
      delete params.domain;
    }
  }
  return params;
};

var resolveParams = function resolveParams(params, extra) {
  var result = [];
  var timestamp = extra && extra.timestamp || 1 * new Date();

  // 统一处理 domain
  applyDomainParam(params);

  // 3. 构建最终的参数字符串
  var queryParts = [];
  for (var key in params) {
    // 排除 adddomain (开关) 和 location (业务要求放最后)
    if (params.hasOwnProperty(key) && key !== 'adddomain' && key !== 'location') {
      var value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        queryParts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
  }

  // 4. 添加 sign 和 time
  if (extra && extra.sign) {
    queryParts.push('sign=' + extra.sign);
  }
  queryParts.push('time=' + timestamp);

  // 5. 最后添加 location
  if (params.location !== undefined) {
    queryParts.push('location=' + encodeURIComponent(params.location));
  }

  return queryParts.join('&');
};
// 动态判断环境（函数方式，支持运行时判断）
var getTestDomain = function getTestDomain() {
  // 优先使用 postMessage 传递的环境信息（srcdoc 模式）
  if (window._ZHINI_ENV && window._ZHINI_ENV.isLocalDev) {
    return true;
  }
  if (window._ZHINI_ENV && window._ZHINI_ENV.baseUrl) {
    var baseUrl = window._ZHINI_ENV.baseUrl;
    if (baseUrl.indexOf('test.qunsou.co/plugin/') !== -1) {
      return true;
    }
    if (baseUrl.indexOf('zhiniplugin.h5bqb.top/customer/widget/') !== -1) {
      return false;
    }
  }
  // 降级：使用 window.location 判断（传统模式）
  // 如果在 iframe 中且 hostname 为空，尝试从父页面获取
  var hostname = window.location.hostname || '';
  if (!hostname && window.parent && window.parent !== window) {
    try {
      hostname = window.parent.location.hostname || '';
    } catch (e) {
      // 跨域时无法访问，忽略错误
    }
  }
  var result = hostname === "test.qunsou.co";
  return result;
};

var resovleDomain = function resovleDomain(params) {
  if (params.thirdDomain) {
    return;
  }
  params.url = (getTestDomain() ? "https://test.qunsou.co" : "https://apiplugin.h5bqb.top") + params.url;
};
var a = "function" == typeof _symbol2.default && "symbol" == (0, _typeof3.default)(_iterator2.default) ? function (e) {
  return typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e);
} : function (e) {
  return e && "function" == typeof _symbol2.default && e.constructor === _symbol2.default && e !== _symbol2.default.prototype ? "symbol" : typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e);
};
var httpRequest = function httpRequest(params) {
  resovleDomain(params);
  params.type = (params.type || "GET").toUpperCase();
  params.dataType = params.dataType || "json";
  params.contentType = params.contentType || "application/x-www-form-urlencoded; charset=UTF-8";
  var httpMethod = void 0;
  if ("undefined" != typeof XMLHttpRequest) {
    httpMethod = new XMLHttpRequest();
  } else {
    for (var i = ["Microsoft.XmlHttp", "MSXML2.XmlHttp", "MSXML2.XmlHttp.3.0", "MSXML2.XmlHttp.4.0", "MSXML2.XmlHttp.5.0", "MSXML2.XmlHttp.6.0"], o = 0, l = i.length; o < l; o++) {
      try {
        httpMethod = new ActiveXObject(i[o]);
        break;
      } catch (c) {}
    }
  }
  httpMethod.onreadystatechange = function () {
    if (4 === httpMethod.readyState) {
      var status = httpMethod.status;
      if (status >= 200 && status < 300) {
        var res = httpMethod.responseText;
        try {
          "json" === params.dataType && res && (res = JSON.parse(res));
        } catch (c) {}
        if (res.sta == 0) {
          params.success && params.success(res, httpMethod.responseXML);
        } else {
          params.error && params.error(res, status, httpMethod);
        }
      } else {
        params.error && params.error(httpMethod.responseText, status, httpMethod);
      }
    }
  };
  if ("GET" === params.type) {
    httpMethod.open("GET", params.url + "?" + resolveParams(params.data), !0);
    httpMethod.send(null);
  } else if ("POST" === params.type) {
    httpMethod.open("POST", "" + params.url, !0);
    !params.fileType && httpMethod.setRequestHeader("Content-Type", params.contentType);
    var u = params.header;
    if (u) {
      for (var f in u) {
        httpMethod.setRequestHeader(f, u[f]);
      }
    }
    var h = params.data;
    if ("object" === ("undefined" == typeof h ? "undefined" : a(h)) && !params.fileType) {
      if (params.contentType && params.contentType.indexOf("application/json") !== -1) {
        applyDomainParam(h);
        delete h.adddomain;
        h = (0, _stringify2.default)(h);
      } else {
        h = (0, _stringify2.default)(h);
      }
    }
    httpMethod.send(h);
  }
  return params.beforeSend && params.beforeSend(httpMethod), httpMethod;
};
var changeInputImg = function changeInputImg(token, files, base64, msgItem, cb) {
  var curFile = void 0;
  var imgFile = void 0;
  if (base64) {
    curFile = files.blob;
    imgFile = curFile.type && curFile.type.indexOf("image") > -1 && curFile.type.indexOf("svg") < 0;
  } else {
    if (files.length == 0) {
      cb(600, { msg: "上传失败，请重新上传！", errcode: 600 });
      return;
    }
    curFile = files[0];
    imgFile = curFile && curFile.type && curFile.type.indexOf("image") > -1 && curFile.type.indexOf("svg") < 0;
    var videoFile = _utils2.default.isVideoFile(curFile.name);

    // 图片限制10M
    if (imgFile && (!curFile || curFile.size > 10 * 1024 * 1024)) {
      cb(600, { msg: "图片的大小不能超过10M！", errcode: 600 });
      return;
    }

    // 视频限制25M
    if (videoFile && (!curFile || curFile.size > 25 * 1024 * 1024)) {
      cb(600, { msg: "视频的大小不能超过25M！", errcode: 600 });
      return;
    }

    // 文件限制25M
    if (!imgFile && !videoFile && (!curFile || curFile.size > 25 * 1024 * 1024)) {
      cb(600, { msg: "文件的大小不能超过25M！", errcode: 600 });
      return;
    }
  }

  var data = new FormData();
  data.append("file", curFile);
  data.append("ftype", imgFile ? "image" : _utils2.default.isVideoFile(curFile.name) ? 'video' : "file");
  data.append("fsize", curFile.size);
  if (msgItem && msgItem.msgtype == "video" && msgItem.width == 0 && msgItem.height == 0) {
    data.append("return_thumb", true);
  }

  var channel_id = _utils2.default.getParameterByName("channel_id");
  var client_id = _utils2.default.getParameterByName("init_client_id_" + channel_id) || _utils2.default.getParameterByName("client_id_" + channel_id);
  var add_params = '&channel_id=' + channel_id + '&client_id=' + client_id + '&ftype=' + (imgFile ? "image" : _utils2.default.isVideoFile(curFile.name) ? 'video' : "file");
  httpRequest({
    type: "POST",
    url: "/wykf/api/v1/enterprise/webplugin/upload?version=0.1.3&token=" + token + add_params,
    data: data,
    fileType: true,
    success: function success(result) {
      cb(0, result.data[0]);
    },
    error: function error(res) {
      cb(-1, {
        msg: res.msg || (imgFile ? "图片" : _utils2.default.isVideoFile(curFile.name) ? "视频" : "文件") + "上传失败！",
        errcode: res.sta,
        token: token
      });
    }
  });
};
exports.default = {
  httpRequest: httpRequest,
  changeInputImg: changeInputImg,
  getTestDomain: getTestDomain
};

/***/ }),

/***/ "qj7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"msg-wrapper":"msg-wrapper","message-status":"message-status","message-status--loading":"message-status--loading","message-status-spin":"message-status-spin","message-status--failed":"message-status--failed","message-tag":"message-tag","more-history":"more-history","content":"content","read-new-message-hint":"read-new-message-hint","message-item":"message-item","name":"name","message-text":"message-text","message-img":"message-img","msg-img":"msg-img","message-right":"message-right","inner-card-outer":"inner-card-outer","inner-card":"inner-card","file-icon":"file-icon","file-size":"file-size","content-img":"content-img","content-title":"content-title","content-des":"content-des"};

/***/ }),

/***/ "tf+u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__("mF0L");

var _utils2 = _interopRequireDefault(_utils);

var _wsUtils = __webpack_require__("GEX2");

var _wsUtils2 = _interopRequireDefault(_wsUtils);

var _content = __webpack_require__("9JCF");

var _content2 = _interopRequireDefault(_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var closeHandlerEvent = void 0;
var iFrameState = 0;
// 添加防重复标志
var isInitializing = false;
var hasInitialized = false;

var getInitUserStorageKey = function getInitUserStorageKey(channelId, field) {
    return 'zhini_init_user_' + field + '_' + channelId;
};

var isValidAvatarUrl = function isValidAvatarUrl(value) {
    if (typeof value !== 'string') {
        return false;
    }
    var url = value.trim();
    if (!/^https?:\/\//i.test(url)) {
        return false;
    }
    try {
        var parsedUrl = new URL(url);
        var pathname = parsedUrl.pathname || '';
        return (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(pathname)
        );
    } catch (e) {
        return false;
    }
};

var saveInitUserValue = function saveInitUserValue(channelId, field, value) {
    if (!channelId || value === undefined) {
        return;
    }
    var stringValue = value === null ? '' : String(value);
    if (field === 'avatar' && !isValidAvatarUrl(stringValue)) {
        return;
    }
    if (field === 'name') {
        window._ZHINI_INIT_USER_NAME = stringValue;
    } else if (field === 'avatar') {
        window._ZHINI_INIT_USER_AVATAR = stringValue;
    }
    try {
        localStorage.setItem(getInitUserStorageKey(channelId, field), stringValue);
    } catch (e) {}
};

var saveInitUserInfo = function saveInitUserInfo(data) {
    if (!data) {
        return;
    }
    var channelId = data.channel_id || localStorage.getItem('zhini_channel_id') || '';
    if (data.name !== undefined) {
        saveInitUserValue(channelId, 'name', data.name);
    } else if (data.nickname !== undefined) {
        saveInitUserValue(channelId, 'name', data.nickname);
    }
    if (data.avatar !== undefined) {
        saveInitUserValue(channelId, 'avatar', data.avatar);
    }
};

var setiFrameState = function setiFrameState(state) {
    iFrameState = state;
};

var handleSpreadActions = function handleSpreadActions() {
    // 延迟500ms后执行，等待 open_chat 接口响应
    _wsUtils2.default.startProcess("setConsultingActive", { active: true, reason: 'spread' });
    _utils2.default.scrollDownEnd(undefined, 0);
    setiFrameState(1);
    if (window.handleZhiniPanelOpen && typeof window.handleZhiniPanelOpen === 'function') {
        window.handleZhiniPanelOpen();
    }
    _wsUtils2.default.startProcess("sendMsgH", { message: { msgtype: 'open_chat' } });
};

var init = function init() {
    window.addEventListener('message', function (event) {
        closeHandlerEvent = event;
        var data = event.data;

        switch (data.type) {
            case 'init':
                {
                    // 收到 init 消息，保存配置信息

                    // 【重要】不再保存 token，因为 InnerWeb 会自己调用 newlogin 验证
                    // SDK 层不再传递 token

                    // 【关键】保存 SDK 传递的 client_id 到全局变量，供 newlogin 使用
                    if (data.client_id) {
                        window._ZHINI_INIT_CLIENT_ID = data.client_id;
                    }

                    saveInitUserInfo(data);

                    // 【重要】保存 config_data 到内存变量（不使用 localStorage）
                    if (data.config_data) {
                        window._ZHINI_CONFIG_DATA = data.config_data;

                        // 【关键】配置保存完成后，立即同步触发样式注入
                        if (window.triggerInitStyles && typeof window.triggerInitStyles === 'function') {
                            // 使用 setTimeout 0，确保在当前事件循环结束后立即执行
                            setTimeout(function () {
                                window.triggerInitStyles();
                            }, 0);
                        }
                    }

                    // 保存 isLocalDev 标志
                    if (data.isLocalDev !== undefined) {
                        localStorage.setItem('zhini_is_local_dev', data.isLocalDev ? 'true' : 'false');
                    }

                    // 【重要】保存 isHide 标志（决定是否调用 newlogin）
                    if (data.isHide !== undefined) {
                        localStorage.setItem('zhini_is_hide_' + data.channel_id, data.isHide ? 'true' : 'false');
                    }

                    break;
                }
            case 'ping':
                {
                    closeHandlerEvent.source.postMessage({ type: 'pong' }, closeHandlerEvent.origin);
                    break;
                }
            case 'largeImg':
                {
                    // 转发给父窗口（SDK iframe）
                    if (window.parent && window.parent !== window) {
                        window.parent.postMessage(data, '*');
                    }
                    break;
                }
            case 'previewVideo':
                {
                    // 转发给父窗口（SDK iframe）
                    if (window.parent && window.parent !== window) {
                        window.parent.postMessage(data, '*');
                    }
                    break;
                }
            case 'panelState':
                {
                    if (data.state === 'open') {
                        _wsUtils2.default.startProcess("setConsultingActive", { active: true, reason: 'panel_open' });
                        setiFrameState(1);
                        if (window.handleZhiniPanelOpen && typeof window.handleZhiniPanelOpen === 'function') {
                            window.handleZhiniPanelOpen();
                        }
                    } else if (data.state === 'close') {
                        _wsUtils2.default.startProcess("setConsultingActive", { active: false, reason: 'panel_close' });
                        setiFrameState(0);
                        if (window.handleZhiniPanelClose && typeof window.handleZhiniPanelClose === 'function') {
                            window.handleZhiniPanelClose();
                        }
                    }
                    break;
                }
            case 'tab_visible':
                {
                    if (window.handleZhiniTabVisible && typeof window.handleZhiniTabVisible === 'function') {
                        window.handleZhiniTabVisible();
                    }
                    break;
                }
            case 'spread':
                {

                    // 防重复检查
                    if (isInitializing) {
                        return;
                    }

                    if (!window.requestHis) {
                        // 【重要】检查 isHide 标志，决定是否调用 newlogin
                        var channelId = localStorage.getItem('zhini_channel_id') || '';
                        var isHide = localStorage.getItem('zhini_is_hide_' + channelId) === 'true';

                        if (!hasInitialized) {

                            // 设置初始化标志，防止重复调用
                            isInitializing = true;
                            hasInitialized = true;

                            // 【关键】如果 isHide 为 true，不调用 newlogin（半初始化状态）
                            if (!isHide) {
                                // InnerWeb 会自己调用 newlogin
                                _content2.default.startProcess();

                                // 延迟调用 requestMessageList，等待 startProcess 完成
                                setTimeout(function () {
                                    if (window.requestMessageList) {
                                        window.requestMessageList("", function (res) {
                                            if (res == 1) {
                                                handleSpreadActions();
                                            }
                                            // 重置初始化标志
                                            isInitializing = false;
                                        });
                                    } else {
                                        handleSpreadActions();
                                        // 重置初始化标志
                                        isInitializing = false;
                                    }
                                }, 1000); // 等待 1 秒让 startProcess 完成
                            } else {
                                // isHide 为 true，不调用 newlogin，直接重置标志
                                // 等待用户调用 showBtn 或 showPanel 时再初始化
                                isInitializing = false;
                            }
                        } else {
                            // 已初始化，直接处理 spread
                            handleSpreadActions();
                        }
                    } else {
                        handleSpreadActions();
                    }
                    break;
                }
        }
        bindHideChatButton();
    }, false);

    // 延迟绑定 onclick 事件处理函数
    function bindHideChatButton() {
        var btnHideChat = document.getElementById('btn-hide-chat');
        if (btnHideChat && closeHandlerEvent) {
            btnHideChat.onclick = function () {
                closeHandlerEvent.source.postMessage({ type: 'hidePanel' }, closeHandlerEvent.origin);
                _wsUtils2.default.startProcess("setConsultingActive", { active: false, reason: 'hide_button' });
                setiFrameState(0);
                if (window.handleZhiniPanelClose && typeof window.handleZhiniPanelClose === 'function') {
                    window.handleZhiniPanelClose();
                }
            };
        } else {
            setTimeout(bindHideChatButton, 100); // 每100毫秒检查一次
        }
    }
};

var postMessage = function postMessage(message) {
    var retryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (!closeHandlerEvent) {
        // 降级方案：直接使用 window.parent
        try {
            window.parent.postMessage(message, '*');
        } catch (error) {}
        // 忽略错误


        // 如果重试次数大于 0，继续重试
        if (retryCount-- > 0) {
            setTimeout(function () {
                postMessage(message, retryCount);
            }, 100);
        }
        return;
    }

    closeHandlerEvent.source.postMessage(message, closeHandlerEvent.origin);
};

exports.default = {
    getifameState: function getifameState() {
        return iFrameState;
    },
    setiFrameState: setiFrameState,
    init: init,
    postMessage: postMessage
};

/***/ }),

/***/ "yjLh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function () {
  window._qqWechatEmotionParser = {};
  window.qqWechatEmotionParser = function () {};
}();

!function () {
  window._qqWechatEmotionParser.emotion_map = [[{ sym: '/::)', en: '[Smile]', cn: '[微笑]' }, { sym: '/::~', en: '[Grimace]', cn: '[撇嘴]' }, { sym: '/::B', en: '[Drool]', cn: '[色]' }, { sym: '/::|', en: '[Scowl]', cn: '[发呆]' }, { sym: '/:8-)', en: '[CoolGuy]', cn: '[得意]' }, { sym: '/::<', en: '[Sob]', cn: '[流泪]' }, { sym: '/::$', en: '[Shy]', cn: '[害羞]' }, { sym: '/::X', en: '[Silent]', cn: '[闭嘴]' }, { sym: '/::Z', en: '[Sleep]', cn: '[睡]' }, { sym: "/::'(", en: '[Cry]', cn: '[大哭]' }, { sym: '/::-|', en: '[Awkward]', cn: '[尴尬]' }, { sym: '/::@', en: '[Angry]', cn: '[发怒]' }, { sym: '/::P', en: '[Tongue]', cn: '[调皮]' }, { sym: '/::D', en: '[Grin]', cn: '[呲牙]' }, { sym: '/::O', en: '[Surprise]', cn: '[惊讶]' }], [{ sym: '/::(', en: '[Frown]', cn: '[难过]' }, { sym: '/::+', en: '[Ruthless]', cn: '[酷]' }, { sym: '/:-b', en: '[Blush]', cn: '[囧]' }, { sym: '/::Q', en: '[Scream]', cn: '[抓狂]' }, { sym: '/::T', en: '[Puke]', cn: '[吐]' }, { sym: '/:,@P', en: '[Chuckle]', cn: '[偷笑]' }, { sym: '/:,@-D', en: '[Joyful]', cn: '[愉快]' }, { sym: '/::d', en: '[Slight]', cn: '[白眼]' }, { sym: '/:,@o', en: '[Smug]', cn: '[傲慢]' }, { sym: '/::g', en: '[Hungry]', cn: '[饥饿]' }, { sym: '/:|-)', en: '[Drowsy]', cn: '[困]' }, { sym: '/::!', en: '[Panic]', cn: '[惊恐]' }, { sym: '/::L', en: '[Sweat]', cn: '[流汗]' }, { sym: '/::>', en: '[Laugh]', cn: '[憨笑]' }, { sym: '/::,@', en: '[Commando]', cn: '[悠闲]' }], [{ sym: '/:,@f', en: '[Determined]', cn: '[奋斗]' }, { sym: '/::-S', en: '[Scold]', cn: '[咒骂]' }, { sym: '/:?', en: '[Shocked]', cn: '[疑问]' }, { sym: '/:,@x', en: '[Shhh]', cn: '[嘘]' }, { sym: '/:,@@', en: '[Dizzy]', cn: '[晕]' }, { sym: '/::8', en: '[Tormented]', cn: '[疯了]' }, { sym: '/:,@!', en: '[Toasted]', cn: '[衰]' }, { sym: '/:!!!', en: '[Skull]', cn: '[骷髅]' }, { sym: '/:xx', en: '[Hammer]', cn: '[敲打]' }, { sym: '/:bye', en: '[Wave]', cn: '[再见]' }, { sym: '/:wipe', en: '[Speechless]', cn: '[擦汗]' }, { sym: '/:dig', en: '[NosePick]', cn: '[抠鼻]' }, { sym: '/:handclap', en: '[Clap]', cn: '[鼓掌]' }, { sym: '/:&-(', en: '[Shame]', cn: '[糗大了]' }, { sym: '/:B-)', en: '[Trick]', cn: '[坏笑]' }], [{ sym: '/:<@', en: '[Bah！L]', cn: '[左哼哼]' }, { sym: '/:@>', en: '[Bah！R]', cn: '[右哼哼]' }, { sym: '/::-O', en: '[Yawn]', cn: '[哈欠]' }, { sym: '/:>-|', en: '[Pooh-pooh]', cn: '[鄙视]' }, { sym: '/:P-(', en: '[Shrunken]', cn: '[委屈]' }, { sym: "/::'|", en: '[TearingUp]', cn: '[快哭了]' }, { sym: '/:X-)', en: '[Sly]', cn: '[阴险]' }, { sym: '/::*', en: '[Kiss]', cn: '[亲亲]' }, { sym: '/:@x', en: '[Wrath]', cn: '[吓]' }, { sym: '/:8*', en: '[Whimper]', cn: '[可怜]' }, { sym: '/:pd', en: '[Cleaver]', cn: '[菜刀]' }, { sym: '/:<W>', en: '[Watermelon]', cn: '[西瓜]' }, { sym: '/:beer', en: '[Beer]', cn: '[啤酒]' }, { sym: '/:basketb', en: '[Basketball]', cn: '[篮球]' }, { sym: '/:oo', en: '[PingPong]', cn: '[乒乓]' }], [{ sym: '/:coffee', en: '[Coffee]', cn: '[咖啡]' }, { sym: '/:eat', en: '[Rice]', cn: '[饭]' }, { sym: '/:pig', en: '[Pig]', cn: '[猪头]' }, { sym: '/:rose', en: '[Rose]', cn: '[玫瑰]' }, { sym: '/:fade', en: '[Wilt]', cn: '[凋谢]' }, { sym: '/:showlove', en: '[Lips]', cn: '[嘴唇]' }, { sym: '/:heart', en: '[Heart]', cn: '[爱心]' }, { sym: '/:break', en: '[BrokenHeart]', cn: '[心碎]' }, { sym: '/:cake', en: '[Cake]', cn: '[蛋糕]' }, { sym: '/:li', en: '[Lightning]', cn: '[闪电]' }, { sym: '/:bome', en: '[Bomb]', cn: '[炸弹]' }, { sym: '/:kn', en: '[Dagger]', cn: '[刀]' }, { sym: '/:footb', en: '[Soccer]', cn: '[足球]' }, { sym: '/:ladybug', en: '[Ladybug]', cn: '[瓢虫]' }, { sym: '/:shit', en: '[Poop]', cn: '[便便]' }], [{ sym: '/:moon', en: '[Moon]', cn: '[月亮]' }, { sym: '/:sun', en: '[Sun]', cn: '[太阳]' }, { sym: '/:gift', en: '[Gift]', cn: '[礼物]' }, { sym: '/:hug', en: '[Hug]', cn: '[拥抱]' }, { sym: '/:strong', en: '[ThumbsUp]', cn: '[强]' }, { sym: '/:weak', en: '[ThumbsDown]', cn: '[弱]' }, { sym: '/:share', en: '[Shake]', cn: '[握手]' }, { sym: '/:v', en: '[Peace]', cn: '[胜利]' }, { sym: '/:@)', en: '[Fight]', cn: '[抱拳]' }, { sym: '/:jj', en: '[Beckon]', cn: '[勾引]' }, { sym: '/:@@', en: '[Fist]', cn: '[拳头]' }, { sym: '/:bad', en: '[Pinky]', cn: '[差劲]' }, { sym: '/:lvu', en: '[RockOn]', cn: '[爱你]' }, { sym: '/:no', en: '[Nuh-uh]', cn: '[NO]' }, { sym: '/:ok', en: '[OK]', cn: '[OK]' }], [{ sym: '/:love', en: '[InLove]', cn: '[爱情]' }, { sym: '/:<L>', en: '[Blowkiss]', cn: '[飞吻]' }, { sym: '/:jump', en: '[Waddle]', cn: '[跳跳]' }, { sym: '/:shake', en: '[Tremble]', cn: '[发抖]' }, { sym: '/:<O>', en: '[Aaagh!]', cn: '[怄火]' }, { sym: '/:circle', en: '[Twirl]', cn: '[转圈]' }, { sym: '/:kotow', en: '[Kotow]', cn: '[磕头]' }, { sym: '/:turn', en: '[Dramatic]', cn: '[回头]' }, { sym: '/:skip', en: '[JumpRope]', cn: '[跳绳]' }, { sym: '/:oY', en: '[Surrender]', cn: '[投降]' }, { sym: '/:#-0', en: '[Hooray]', cn: '[激动]' }, { sym: '/:hiphot', en: '[Meditate]', cn: '[乱舞]' }, { sym: '/:kiss', en: '[Smooch]', cn: '[献吻]' }, { sym: '/:<&', en: '[TaiChi L]', cn: '[左太极]' }, { sym: '/:&>', en: '[TaiChi R]', cn: '[右太极]' }], [{ sym: '', en: '[Hey]', cn: '[嘿哈]' }, { sym: '', en: '[Facepalm]', cn: '[捂脸]' }, { sym: '', en: '[Smirk]', cn: '[奸笑]' }, { sym: '', en: '[Smart]', cn: '[机智]' }, { sym: '', en: '[Concerned]', cn: '[皱眉]' }, { sym: '', en: '[Yeah!]', cn: '[耶]' }, { sym: '', en: '[Chicken]', cn: '[鸡]' }, { sym: '', en: '[Packet]', cn: '[红包]' }, { sym: '', en: '[Rich]', cn: '[發]' }, { sym: '', en: '[Pup]', cn: '[小狗]' }, { sym: '', en: '[OnLooker]', cn: '[吃瓜]' }, { sym: '', en: '[GoForIt]', cn: '[加油]' }, { sym: '', en: '[Sweats]', cn: '[汗]' }, { sym: '', en: '[OMG]', cn: '[天啊]' }, { sym: '', en: '[Emm]', cn: '[Emm]' }], [{ sym: '', en: '[Respect]', cn: '[社会社会]' }, { sym: '', en: '[Doge]', cn: '[旺柴]' }, { sym: '', en: '[NoProb]', cn: '[好的]' }, { sym: '', en: '[MyBad]', cn: '[打脸]' }, { sym: '', en: '[Wow]', cn: '[哇]' }, { sym: '', en: '[Boring]', cn: '[翻白眼]' }, { sym: '', en: '[Awesome]', cn: '[666]' }, { sym: '', en: '[LetMeSee]', cn: '[让我看看]' }, { sym: '', en: '[Sigh]', cn: '[叹气]' }, { sym: '', en: '[Hurt]', cn: '[苦涩]' }, { sym: '', en: '[Broken]', cn: '[裂开]' }]];
}();
!function () {
  function Trie() {
    this.words = 0;
    this.empty = 1;
    this.index = 0;
    this.children = {};
  }

  Trie.prototype = {
    insert: function insert(str, pos, idx) {
      if (str.length === 0) {
        return;
      }
      var T = this;
      var k;
      var child;

      if (pos === undefined) {
        pos = 0;
      }
      if (pos === str.length) {
        T.index = idx;
        return;
      }
      k = str[pos];
      if (T.children[k] === undefined) {
        T.children[k] = new Trie();
        T.empty = 0;
        T.children[k].words = this.words + 1;
      }
      child = T.children[k];
      child.insert(str, pos + 1, idx);
    },

    build: function build(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr[i].length; j++) {
          for (var k in arr[i][j]) {
            var item = arr[i][j][k];
            if (item) {
              this.insert(item, 0, [i, j, k]);
              // emotion_list.push({key: emotion_map[i][j][k], i: i, j: j});
            }
          }
        }
      }
      // var len = arr.length;
      // for (var i = 0; i < len; i++) {
      //     this.insert(arr[i], 0, i);
      // }
    },

    searchOne: function searchOne(str, pos) {
      if (pos === undefined) {
        pos = 0;
      }
      var result = {};
      if (str.length === 0) return result;
      var T = this;
      var child;
      var k;
      result.arr = [];
      k = str[pos];
      child = T.children[k];
      if (child !== undefined && pos < str.length) {
        return child.searchOne(str, pos + 1);
      }
      if (child === undefined && T.empty === 0) return result;
      if (T.empty == 1) {
        result.arr[0] = pos - T.words;
        result.arr[1] = T.index;
        result.words = T.words;
        return result;
      }
      return result;
    },

    search: function search(str) {
      if (this.empty == 1) return [];
      var len = str.length;
      var searchResult = [];
      var tmp;
      for (var i = 0; i < len - 1; i++) {
        tmp = this.searchOne(str, i);
        if (typeof tmp.arr !== "undefined" && tmp.arr.length > 0) {
          searchResult.push(tmp.arr);
          i = i + tmp.words - 1;
        }
      }
      return searchResult;
    }
  };

  if (typeof window !== "undefined") {
    window._qqWechatEmotionParser.Trie = Trie;
  }
}();

!function () {
  var emotion_map, trie, emotion_list, Trie;

  if (window !== "undefined") {
    emotion_map = window._qqWechatEmotionParser.emotion_map;
    Trie = window._qqWechatEmotionParser.Trie;
    build();
    window.qqWechatEmotionParser = qqWechatEmotionParser;
  }

  function build() {
    // emotion_list = keys(emotion_map);
    trie = new Trie();
    trie.build(emotion_map);
  }

  function qqWechatEmotionParser(str) {
    var indices = trie.search(str);
    indices.reverse().map(function (idx) {
      var indexes = idx[1];
      var item = emotion_map[indexes[0]][indexes[1]];
      // var pos = idx[0], emotion = emotion_list[idx[1]];
      var img = '<img class="wx-emo-img" style="background-position: ' + -20 * indexes[1] + 'px ' + -20 * indexes[0] + 'px" src="https://wx.qq.com/zh_CN/htmledition/v2/images/spacer.gif" alt="' + item[indexes[2]] + '">';
      // img = '<img src="' + emotion_map[emotion] + '" alt="' + emotion + '">';
      str = splice(str, idx[0], item[indexes[2]].length, img);
    });
    return str;
  }

  function splice(str, index, count, add) {
    return str.slice(0, index) + add + str.slice(index + count);
  }

  function keys(map) {
    var list = [];
    for (var k in map) {
      if (map.hasOwnProperty(k)) list.push(k);
    }
    return list;
  }
}();

/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// static/js/index.js